[
  [
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T00:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 0,
      "timestamp": "2023-02-27T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 784,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 766,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 501,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 492,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 323,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 236,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 15,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 10,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 8,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 6,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 6,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 5,
      "timestamp": "2023-02-27T01:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    },
    {
      "label": "Norfolk State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T01:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 930,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 809,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 664,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 593,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 582,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 260,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 71,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 46,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 16,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 9,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 8,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 5
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 3,
      "timestamp": "2023-02-27T02:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T02:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 1017,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 932,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 869,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 741,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 683,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 272,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 75,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 55,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 17,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 10,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 9,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 5
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 4,
      "timestamp": "2023-02-27T03:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T03:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 1131,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 1128,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 910,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 789,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 705,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 279,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 79,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 55
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 30,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 20,
      "timestamp": "2023-02-27T04:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 10
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 9
    },
    {
      "label": "North Carolina Central University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 5
    },
    {
      "label": "Norfolk State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T04:00:00-05:00",
      "votes": 0
    }
  ],
  [
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 1553,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 1429,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 961,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 843,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 779,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 287,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 84,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 60,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 47,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 30
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 11,
      "timestamp": "2023-02-27T05:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 10
    },
    {
      "label": "North Carolina Central University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T05:00:00-05:00",
      "votes": 5
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 1,
      "timestamp": "2023-02-27T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 1789,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 1567,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 1005,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 918,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 869,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 315,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 86,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 74,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 73,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 31,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 14,
      "timestamp": "2023-02-27T06:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 10
    },
    {
      "label": "North Carolina Central University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T06:00:00-05:00",
      "votes": 5
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2,
      "timestamp": "2023-02-27T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 1951,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 1789,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 1134,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 1043,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 913,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 385,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 118,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Howard University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 86
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 73
    },
    {
      "label": "Winston-Salem State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 31
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 17,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T07:00:00-05:00",
      "votes": 10
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 7,
      "timestamp": "2023-02-27T07:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 5,
      "timestamp": "2023-02-27T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 2111,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 2109,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 1289,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 1190,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 1001,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 453,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 151,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 96,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 77,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 34,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 33,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 23,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 9,
      "timestamp": "2023-02-27T08:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "color": "#f96302",
      "timestamp": "2023-02-27T08:00:00-05:00",
      "votes": 5
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 2314,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 2201,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 1640,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 1504,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 1470,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 551,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 265,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 206,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 84,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 49,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 34,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 26,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 10,
      "timestamp": "2023-02-27T09:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 7,
      "timestamp": "2023-02-27T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 2653,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 2552,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 2053,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 1876,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 1723,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 704,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 383,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 246,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 127,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 52,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 38,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 35,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 14,
      "timestamp": "2023-02-27T10:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 11,
      "timestamp": "2023-02-27T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 3222,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 3166,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 3047,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 2333,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 2030,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 811,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 546,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 322,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 132,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 112,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 77,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 39,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 18,
      "timestamp": "2023-02-27T11:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 17,
      "timestamp": "2023-02-27T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 4373,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 4062,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 3549,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 2598,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 2509,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 908,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 610,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 366,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 254,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 235,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 155,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 42,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 22,
      "timestamp": "2023-02-27T12:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 20,
      "timestamp": "2023-02-27T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 5363,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 4773,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 3772,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 3004,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 2778,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 1133,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 680,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 467,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 389,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 367,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 182,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 106,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 50,
      "timestamp": "2023-02-27T13:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 45,
      "timestamp": "2023-02-27T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 6337,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 5761,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 4010,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 3757,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 3314,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 1340,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 754,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 647,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 545,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 465,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 217,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 168,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61,
      "timestamp": "2023-02-27T14:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 51,
      "timestamp": "2023-02-27T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 7433,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 6688,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 4706,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 4234,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 3573,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 1664,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 884,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 875,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 826,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 558,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 235,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 214,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 64,
      "timestamp": "2023-02-27T15:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 55,
      "timestamp": "2023-02-27T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 8322,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 7817,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 5326,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 4597,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 3838,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 1978,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 1011,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 1008,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 941,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 639,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 267,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 242,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 71,
      "timestamp": "2023-02-27T16:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 56,
      "timestamp": "2023-02-27T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 9862,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 9416,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 6407,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 5199,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 4246,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 2194,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 1414,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 1142,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1033,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 760,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 299,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 262,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 78,
      "timestamp": "2023-02-27T17:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 62,
      "timestamp": "2023-02-27T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 11044,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 10624,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 6967,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 5460,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 4605,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 2319,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 1857,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 1270,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1071,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 901,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 363,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 341,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 93,
      "timestamp": "2023-02-27T18:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 69,
      "timestamp": "2023-02-27T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 12647,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 11366,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 7457,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 5877,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 4905,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 2770,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 2353,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 1364,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1144,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 1080,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 383,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 380,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 104,
      "timestamp": "2023-02-27T19:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 101,
      "timestamp": "2023-02-27T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 13990,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 12293,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 8424,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 6520,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 5293,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 3261,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 3134,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 1524,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1188,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 1175,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 453,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 398,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 138,
      "timestamp": "2023-02-27T20:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 114,
      "timestamp": "2023-02-27T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 15223,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 13520,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 8799,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 7026,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 5830,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 3946,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 3392,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 1724,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 1308,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1239,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 518,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 493,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 147,
      "timestamp": "2023-02-27T21:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 123,
      "timestamp": "2023-02-27T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 16096,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 14491,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 9334,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 7595,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 6176,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 4639,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 3522,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 1812,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 1398,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1284,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 665,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 554,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 153,
      "timestamp": "2023-02-27T22:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 133,
      "timestamp": "2023-02-27T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 16673,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 15210,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 9611,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 8254,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 6381,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 4903,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 3575,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 1858,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 1466,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1337,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 720,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 623,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 161,
      "timestamp": "2023-02-27T23:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 136,
      "timestamp": "2023-02-27T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 17160,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 15936,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 9975,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 8439,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 6651,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 5254,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 3618,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 1880,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 1522,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1401,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 783,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 682,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 165,
      "timestamp": "2023-02-28T00:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 142,
      "timestamp": "2023-02-28T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 17660,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 16621,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 10119,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 8494,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 6857,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 5463,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 3629,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 1890,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 1686,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1423,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 899,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 701,
      "timestamp": "2023-02-28T01:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T01:00:00-05:00",
      "votes": 165
    },
    {
      "label": "Winston-Salem State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T01:00:00-05:00",
      "votes": 142
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 18008,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 17120,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 10160,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 8581,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 7004,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 5720,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 3644,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 1909,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 1808,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1432,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 1014,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 727,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 167,
      "timestamp": "2023-02-28T02:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 143,
      "timestamp": "2023-02-28T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 18073,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 17619,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 10310,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 8741,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 7072,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 5904,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 3654,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 1958,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 1915,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1441,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 1023,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 750,
      "timestamp": "2023-02-28T03:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T03:00:00-05:00",
      "votes": 167
    },
    {
      "label": "Winston-Salem State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T03:00:00-05:00",
      "votes": 143
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 18219,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 18032,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 10331,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 8917,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 7091,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 5944,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 3672,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 2004,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 1920,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1447,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 1034,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 761,
      "timestamp": "2023-02-28T04:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T04:00:00-05:00",
      "votes": 167
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 146,
      "timestamp": "2023-02-28T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 18425,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 18394,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 10362,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 9024,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 7175,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 5966,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 3706,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 2011,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 1950,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1461,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 1040,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "color": "#f96302",
      "timestamp": "2023-02-28T05:00:00-05:00",
      "votes": 761
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 169,
      "timestamp": "2023-02-28T05:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 148,
      "timestamp": "2023-02-28T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 19002,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 18730,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 10487,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 9635,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 7375,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 6009,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 3756,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 2031,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 1976,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1491,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 1063,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 770,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 182,
      "timestamp": "2023-02-28T06:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 149,
      "timestamp": "2023-02-28T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 19688,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 19675,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 10606,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 9723,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 7529,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 6099,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 4002,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 2055,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 2028,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1517,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 1102,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 849,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 188,
      "timestamp": "2023-02-28T07:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 156,
      "timestamp": "2023-02-28T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 20799,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 20128,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 10815,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 9983,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 7758,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 6187,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 4138,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 2180,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 2152,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1560,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 1210,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 890,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 197,
      "timestamp": "2023-02-28T08:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 166,
      "timestamp": "2023-02-28T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 21491,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 20940,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 11487,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 10409,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 8102,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 6546,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 4285,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 2306,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 2280,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1624,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 1261,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 951,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 203,
      "timestamp": "2023-02-28T09:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 181,
      "timestamp": "2023-02-28T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 22291,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 21568,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 11948,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 10943,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 8548,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 7003,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 4520,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 2398,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 2376,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1706,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 1320,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1005,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 217,
      "timestamp": "2023-02-28T10:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 194,
      "timestamp": "2023-02-28T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 23313,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 22628,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 12480,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 11300,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 9034,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 7402,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 4674,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 2552,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 2533,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1751,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 1455,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1025,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 224,
      "timestamp": "2023-02-28T11:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 215,
      "timestamp": "2023-02-28T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 24361,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 23092,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 12799,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 11644,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 9259,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 7724,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 4823,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 2731,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 2619,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1806,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 1508,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1043,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 237,
      "timestamp": "2023-02-28T12:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 225,
      "timestamp": "2023-02-28T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 25504,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 23453,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 13176,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 11836,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 9391,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 8077,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 4954,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 2847,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 2730,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1836,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 1530,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1084,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 247,
      "timestamp": "2023-02-28T13:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 231,
      "timestamp": "2023-02-28T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 26424,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 23814,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 13405,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 12138,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 9578,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 8282,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 5105,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 2893,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 2883,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 1965,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 1809,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1125,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 252,
      "timestamp": "2023-02-28T14:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 246,
      "timestamp": "2023-02-28T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 27230,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 24244,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 13885,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 12493,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 9840,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 8554,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 5247,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 3031,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 2924,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2103,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 1955,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1159,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 388,
      "timestamp": "2023-02-28T15:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 299,
      "timestamp": "2023-02-28T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 27919,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 24546,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 14298,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 13014,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 10200,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 8864,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 5450,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 3106,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3013,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2164,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2018,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1184,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 512,
      "timestamp": "2023-02-28T16:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 322,
      "timestamp": "2023-02-28T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 28765,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 25167,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 14752,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 13453,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 10411,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 9209,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 5548,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3174,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 3168,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2284,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2073,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1205,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 714,
      "timestamp": "2023-02-28T17:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 336,
      "timestamp": "2023-02-28T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 29553,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 25531,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 15187,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 13537,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 10672,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 9502,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 5669,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3354,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 3251,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2423,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2178,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1230,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 871,
      "timestamp": "2023-02-28T18:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 345,
      "timestamp": "2023-02-28T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 30330,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 26624,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 15398,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 14222,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 11039,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 9827,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 5856,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3466,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 3333,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2486,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2205,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 1381,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1278,
      "timestamp": "2023-02-28T19:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 361,
      "timestamp": "2023-02-28T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 31297,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 27896,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 15730,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 15070,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 11300,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 10075,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 5968,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3567,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 3364,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2550,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2248,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 1645,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1324,
      "timestamp": "2023-02-28T20:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 381,
      "timestamp": "2023-02-28T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 32554,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 29354,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 16330,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 15644,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 11752,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 10343,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 6166,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3646,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 3534,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2605,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2279,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 1929,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1346,
      "timestamp": "2023-02-28T21:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 393,
      "timestamp": "2023-02-28T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 33430,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 30291,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 17044,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 16146,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 12057,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 10683,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 6306,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3773,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 3618,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2639,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2305,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 2106,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1388,
      "timestamp": "2023-02-28T22:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 397,
      "timestamp": "2023-02-28T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 34142,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 30896,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 17815,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 16797,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 12376,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 10944,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 6368,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3825,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 3724,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2699,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2330,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 2156,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1400,
      "timestamp": "2023-02-28T23:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 402,
      "timestamp": "2023-02-28T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 34659,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 31562,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 18138,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 17164,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 12473,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 11186,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 6408,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3838,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 3751,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2716,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2336,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 2167,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1411,
      "timestamp": "2023-03-01T00:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 408,
      "timestamp": "2023-03-01T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 35129,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 32046,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 18361,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 17217,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 12618,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 11312,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 6502,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3853,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 3806,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2721,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2339,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 2188,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1423,
      "timestamp": "2023-03-01T01:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 410,
      "timestamp": "2023-03-01T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 35429,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 32448,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 18393,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 17241,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 12665,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 11451,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 6513,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 3866,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3863,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2725,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T02:00:00-05:00",
      "votes": 2339
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 2202,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1436,
      "timestamp": "2023-03-01T02:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 412,
      "timestamp": "2023-03-01T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 35683,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 32724,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 18449,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 17321,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 12801,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 11525,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 6533,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 3955,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3866,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2729,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T03:00:00-05:00",
      "votes": 2339
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 2259,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1443,
      "timestamp": "2023-03-01T03:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 413,
      "timestamp": "2023-03-01T03:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 35855,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 33174,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 18617,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 17736,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 12911,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 11554,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 6545,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 4170,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3871,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2740,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2342,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 2275,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1451,
      "timestamp": "2023-03-01T04:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "color": "#f96302",
      "timestamp": "2023-03-01T04:00:00-05:00",
      "votes": 413
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 36070,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 33585,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 18685,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 17832,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 12968,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 11574,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 6577,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 4341,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3890,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2752,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 2388,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2349,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1471,
      "timestamp": "2023-03-01T05:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 420,
      "timestamp": "2023-03-01T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 36247,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 33959,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 18836,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 18177,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 13069,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 11591,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 6638,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 4439,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3893,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2777,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 2512,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2358,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1527,
      "timestamp": "2023-03-01T06:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 435,
      "timestamp": "2023-03-01T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 36552,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 34586,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 18960,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 18289,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 13198,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 11665,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 6765,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 4518,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3913,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2836,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 2653,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2384,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1561,
      "timestamp": "2023-03-01T07:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 450,
      "timestamp": "2023-03-01T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 37137,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 35093,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 19179,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 18504,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 13431,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 11730,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 7147,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 4612,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3939,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 2914,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 2745,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2415,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1606,
      "timestamp": "2023-03-01T08:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 466,
      "timestamp": "2023-03-01T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 37999,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 35903,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 19621,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 18815,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 13662,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 11977,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 7570,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 4655,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 3985,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 3008,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 2880,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2452,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1658,
      "timestamp": "2023-03-01T09:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 489,
      "timestamp": "2023-03-01T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 38716,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 36712,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 20035,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 19116,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 13984,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 12216,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 8002,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 4722,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 4011,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 3287,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 3159,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2474,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1687,
      "timestamp": "2023-03-01T10:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 642,
      "timestamp": "2023-03-01T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 39291,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 37252,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 20302,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 19365,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 14358,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 12460,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 8237,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 4848,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 4065,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 3553,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 3260,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2491,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1697,
      "timestamp": "2023-03-01T11:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 704,
      "timestamp": "2023-03-01T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 40241,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 37740,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 20683,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 19515,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 14591,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 12858,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 8748,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 4985,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 4104,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 3714,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 3414,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2499,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1711,
      "timestamp": "2023-03-01T12:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 748,
      "timestamp": "2023-03-01T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 41148,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 38174,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 20856,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 19598,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 14722,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 13140,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 9286,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 5199,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 4159,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 3916,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 3502,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2538,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1748,
      "timestamp": "2023-03-01T13:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 817,
      "timestamp": "2023-03-01T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 42439,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 39879,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 21299,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 20212,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 15127,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 13617,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 9780,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 5540,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 5102,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 4198,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 3650,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2568,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1827,
      "timestamp": "2023-03-01T14:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 850,
      "timestamp": "2023-03-01T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 44016,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 42033,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 21769,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 20389,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 15373,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 14166,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 10109,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 5776,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 5724,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 4276,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 3699,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2629,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1940,
      "timestamp": "2023-03-01T15:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 890,
      "timestamp": "2023-03-01T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 45585,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 43693,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 22223,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 21789,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 15736,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 14992,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 10414,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 6483,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 6041,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 4360,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 3784,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2652,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 1970,
      "timestamp": "2023-03-01T16:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1145,
      "timestamp": "2023-03-01T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 47652,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 44732,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 23624,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 22619,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 16219,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 15618,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 10733,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 7099,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 6177,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 4434,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 4202,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2757,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 2062,
      "timestamp": "2023-03-01T17:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1333,
      "timestamp": "2023-03-01T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 49220,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 45684,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 24883,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 23319,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 16518,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 16493,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 11283,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 7697,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 6305,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 4478,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 4405,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2802,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 2312,
      "timestamp": "2023-03-01T18:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1349,
      "timestamp": "2023-03-01T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 50631,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 47485,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 26227,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 23767,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 17184,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 16855,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 11780,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 8213,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 6474,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 4662,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 4557,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2860,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 2582,
      "timestamp": "2023-03-01T19:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1400,
      "timestamp": "2023-03-01T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 52501,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 48889,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 27886,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 24360,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 17967,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 17525,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 12773,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 8884,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 6596,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 4909,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 4732,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 2936,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 2856,
      "timestamp": "2023-03-01T20:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1446,
      "timestamp": "2023-03-01T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 53681,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 49862,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 29373,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 24907,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 18994,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 18155,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 13381,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 9502,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 6900,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 5290,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 4836,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 3365,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 3036,
      "timestamp": "2023-03-01T21:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1525,
      "timestamp": "2023-03-01T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 54950,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 51984,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 30777,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 25840,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 19650,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 18899,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 14086,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 9951,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 7074,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 5508,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 4966,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 3617,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 3168,
      "timestamp": "2023-03-01T22:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1629,
      "timestamp": "2023-03-01T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 56893,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 56617,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 32120,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 26307,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 20336,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 19217,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 14510,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 10298,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 7198,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 5596,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 5042,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 3641,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 3228,
      "timestamp": "2023-03-01T23:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1661,
      "timestamp": "2023-03-01T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 61838,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 59498,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 32725,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 26567,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 21109,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 19341,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 14941,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 10352,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 7285,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 5796,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 5054,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 3734,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 3245,
      "timestamp": "2023-03-02T00:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1676,
      "timestamp": "2023-03-02T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 64092,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 63146,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 33017,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 26673,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 21438,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 19407,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 15346,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 10406,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 7394,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 5837,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 5118,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 3744,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 3249,
      "timestamp": "2023-03-02T01:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1693,
      "timestamp": "2023-03-02T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 66833,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 63648,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 33042,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 26782,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 21977,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 19706,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 15608,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 10418,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 7422,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 5851,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 5214,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 3826,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 3253,
      "timestamp": "2023-03-02T02:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1705,
      "timestamp": "2023-03-02T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 67281,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 64065,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 33212,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 26924,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 22121,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 19768,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 15655,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 10444,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 7435,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 5855,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 5223,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 3829,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 3256,
      "timestamp": "2023-03-02T03:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1709,
      "timestamp": "2023-03-02T03:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 67564,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 64674,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 33392,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 26979,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 22169,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 19941,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 15675,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 10535,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 7598,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 5861,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 5226,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 3849,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 3276,
      "timestamp": "2023-03-02T04:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1713,
      "timestamp": "2023-03-02T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 67780,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 65722,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 33562,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 27074,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 22235,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 20048,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 15718,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 10586,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 7738,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 5866,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 5229,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 3856,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 3302,
      "timestamp": "2023-03-02T05:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1754,
      "timestamp": "2023-03-02T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 68411,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 67172,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 34464,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 27278,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 22307,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 20219,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 15914,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 10734,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 7846,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 5956,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 5247,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 3979,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 3321,
      "timestamp": "2023-03-02T06:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1773,
      "timestamp": "2023-03-02T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 70408,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 69200,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 34897,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 27464,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 22540,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 20619,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 16110,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 11073,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 8089,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 6040,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 5409,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 4031,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 3341,
      "timestamp": "2023-03-02T07:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1814,
      "timestamp": "2023-03-02T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 72647,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 71225,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 35311,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 27725,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 22766,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 21042,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 16578,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 11403,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 8294,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 6129,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 5589,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 4067,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 3448,
      "timestamp": "2023-03-02T08:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 1928,
      "timestamp": "2023-03-02T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 75391,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 73840,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 36457,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 28093,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 23324,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 21697,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 17300,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 11727,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 8415,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 6223,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 5712,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 4305,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 3666,
      "timestamp": "2023-03-02T09:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 2051,
      "timestamp": "2023-03-02T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 78256,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 77406,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 37314,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 28332,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 23784,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 22023,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 17918,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 11913,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 8768,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 6447,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 5844,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 4360,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 3764,
      "timestamp": "2023-03-02T10:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 2296,
      "timestamp": "2023-03-02T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 82322,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 81349,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 38115,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 28649,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 24530,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 22514,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 18380,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 12135,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 9284,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 6635,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 5915,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 4402,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 3965,
      "timestamp": "2023-03-02T11:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 2393,
      "timestamp": "2023-03-02T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 85222,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 84195,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 38545,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 29342,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 24854,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 22904,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 18641,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 12473,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 9501,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 6681,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 6121,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 4437,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 4124,
      "timestamp": "2023-03-02T12:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 2541,
      "timestamp": "2023-03-02T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 87751,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 86682,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 39100,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 29748,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 25241,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 23289,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 19296,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 12973,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 9681,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 6742,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 6254,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 4631,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 4269,
      "timestamp": "2023-03-02T13:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 2659,
      "timestamp": "2023-03-02T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 92143,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 91106,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 39625,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 30241,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 25690,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 23942,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 19665,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 13216,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 10031,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 6831,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 6456,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 4717,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 4713,
      "timestamp": "2023-03-02T14:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 2774,
      "timestamp": "2023-03-02T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 95578,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 93807,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 40451,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 30655,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 26182,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 24471,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 20170,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 13493,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 10169,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 7112,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 6861,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 5029,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 4825,
      "timestamp": "2023-03-02T15:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 2872,
      "timestamp": "2023-03-02T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 98865,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 96102,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 41382,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 31075,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 26636,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 25101,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 21000,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 13955,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 10689,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 7457,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 6994,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 5318,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 4878,
      "timestamp": "2023-03-02T16:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 3010,
      "timestamp": "2023-03-02T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 101494,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 98819,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 42163,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 31635,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 27325,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 25391,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 21404,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 14683,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 11210,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 7803,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 7054,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 5533,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5036,
      "timestamp": "2023-03-02T17:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 3087,
      "timestamp": "2023-03-02T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 103623,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 101744,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 42759,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 32077,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 28062,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 26062,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 21797,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 15168,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 11439,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 8119,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 7078,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 5702,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5174,
      "timestamp": "2023-03-02T18:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 3116,
      "timestamp": "2023-03-02T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 108839,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 107341,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 43752,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 32541,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 28896,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 26557,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 22388,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 15674,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 11612,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 8444,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 7374,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 6260,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5235,
      "timestamp": "2023-03-02T19:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 3177,
      "timestamp": "2023-03-02T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 115353,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 110982,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 44808,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 33051,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 29690,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 27026,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 23440,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 16188,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 11808,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 8631,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 7491,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 6554,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5318,
      "timestamp": "2023-03-02T20:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 3273,
      "timestamp": "2023-03-02T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 121505,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 113671,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 45402,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 34153,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 30481,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 27620,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 24127,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 16731,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 11897,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 8827,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 7619,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 6784,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5487,
      "timestamp": "2023-03-02T21:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 3507,
      "timestamp": "2023-03-02T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 126565,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 117159,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 46148,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 34946,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 30896,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 28271,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 24747,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 17607,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 12045,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 8991,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 7663,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 6942,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5546,
      "timestamp": "2023-03-02T22:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 3638,
      "timestamp": "2023-03-02T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 129784,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 120864,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 46917,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 35446,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 31308,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 28791,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 25059,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 18068,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 12155,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 9089,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 7734,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 7116,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5613,
      "timestamp": "2023-03-02T23:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 3857,
      "timestamp": "2023-03-02T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 131621,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 122370,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 47382,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 35628,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 31534,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 29264,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 25231,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 18189,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 12238,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 9115,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 7756,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 7283,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5663,
      "timestamp": "2023-03-03T00:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 3958,
      "timestamp": "2023-03-03T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 132586,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 122904,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 47510,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 35716,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 31758,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 29470,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 25330,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 18260,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 12249,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 9151,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 7763,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 7309,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5677,
      "timestamp": "2023-03-03T01:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 4002,
      "timestamp": "2023-03-03T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 133211,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 123352,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 47702,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 35874,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 31795,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 29704,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 25424,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 18286,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 12263,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 9180,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 7777,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 7327,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5683,
      "timestamp": "2023-03-03T02:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 4005,
      "timestamp": "2023-03-03T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 133962,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 123851,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 47853,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 36159,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 31902,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 30012,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 25471,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 18433,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 12267,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 9217,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 7784,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 7334,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5685,
      "timestamp": "2023-03-03T03:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 4008,
      "timestamp": "2023-03-03T03:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 134613,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 124226,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 48204,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 36271,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 31912,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 30192,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 25500,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 18442,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 12391,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 9230,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 7791,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 7439,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5688,
      "timestamp": "2023-03-03T04:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 4015,
      "timestamp": "2023-03-03T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 135363,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 124940,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 48514,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 36371,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 31965,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 30273,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 25534,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 18685,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 12488,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 9252,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 7883,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 7496,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5706,
      "timestamp": "2023-03-03T05:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 4022,
      "timestamp": "2023-03-03T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 136621,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 125682,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 49079,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 36525,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 32160,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 30432,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 26054,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 18913,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 12531,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 9289,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 8003,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 7559,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5732,
      "timestamp": "2023-03-03T06:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 4050,
      "timestamp": "2023-03-03T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 138235,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 126851,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 49622,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 36809,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 32325,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 30680,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 26361,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 19081,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 12621,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 9376,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 8043,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 7601,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5769,
      "timestamp": "2023-03-03T07:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 4150,
      "timestamp": "2023-03-03T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 140306,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 128020,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 50160,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 37200,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 32556,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 31244,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 26652,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 19465,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 12795,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 9684,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 8109,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 7865,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5786,
      "timestamp": "2023-03-03T08:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 4319,
      "timestamp": "2023-03-03T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 142261,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 129360,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 50628,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 37630,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 33200,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 31651,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 26885,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 19768,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 12958,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 9810,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 8183,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 8029,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5836,
      "timestamp": "2023-03-03T09:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 4424,
      "timestamp": "2023-03-03T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 143991,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 130955,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 51078,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 37828,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 33650,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 32097,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 27230,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 20222,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 13206,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 10120,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 8361,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 8291,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5870,
      "timestamp": "2023-03-03T10:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 4468,
      "timestamp": "2023-03-03T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 146277,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 132897,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 51362,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 38227,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 34238,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 32485,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 27686,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 20770,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 13369,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 10223,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 8616,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 8503,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5915,
      "timestamp": "2023-03-03T11:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 4654,
      "timestamp": "2023-03-03T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 147673,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 134195,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 51708,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 38696,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 34518,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 33026,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 28488,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 21213,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 13474,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 10402,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 9002,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 8546,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 5986,
      "timestamp": "2023-03-03T12:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 4751,
      "timestamp": "2023-03-03T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 149448,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 136823,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 52036,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 39202,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 34737,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 33523,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 29051,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 21418,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 13723,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 10635,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 9387,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 8604,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6043,
      "timestamp": "2023-03-03T13:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 4954,
      "timestamp": "2023-03-03T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 151256,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 139553,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 52445,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 39366,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 35218,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 34052,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 29504,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 21877,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 13904,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 10796,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 9653,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 8736,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6093,
      "timestamp": "2023-03-03T14:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 5008,
      "timestamp": "2023-03-03T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 153233,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 142572,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 52738,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 39705,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 35472,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 34537,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 29804,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 22290,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 14037,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 10975,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 9936,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 8864,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6150,
      "timestamp": "2023-03-03T15:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 5122,
      "timestamp": "2023-03-03T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 155144,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 145954,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 53179,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 40277,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 35829,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 35098,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 30456,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 22648,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 14188,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 11136,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 10144,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 8941,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6208,
      "timestamp": "2023-03-03T16:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 5184,
      "timestamp": "2023-03-03T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 157205,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 148640,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 53550,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 40745,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 36508,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 36198,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 31436,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 22946,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 14379,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 11428,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 10208,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 8974,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6227,
      "timestamp": "2023-03-03T17:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 5279,
      "timestamp": "2023-03-03T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 159372,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 151035,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 54138,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 41279,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 37678,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 36564,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 32129,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 23450,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 14544,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 11799,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 10334,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9036,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6246,
      "timestamp": "2023-03-03T18:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 5351,
      "timestamp": "2023-03-03T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 161969,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 153946,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 54750,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 41749,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 38888,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 37241,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 32746,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 23830,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 14824,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 12061,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 10452,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9143,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6310,
      "timestamp": "2023-03-03T19:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 5592,
      "timestamp": "2023-03-03T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 165136,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 157718,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 55593,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 42311,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 39782,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 38020,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 33012,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 24197,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 15038,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 12367,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 10634,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9189,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6375,
      "timestamp": "2023-03-03T20:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 5810,
      "timestamp": "2023-03-03T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 168478,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 161048,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 56877,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 43018,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 40870,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 38602,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 33393,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 24534,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 15219,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 12419,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 10781,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9431,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6419,
      "timestamp": "2023-03-03T21:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 6001,
      "timestamp": "2023-03-03T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 172423,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 163603,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 57314,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 43527,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 41622,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 39155,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 33795,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 24760,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 15370,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 12483,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 10995,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9467,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6451,
      "timestamp": "2023-03-03T22:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 6081,
      "timestamp": "2023-03-03T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 175492,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 166847,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 57825,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 44235,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 42712,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 39502,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 34051,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 24989,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 15448,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 12841,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 11230,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9505,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6467,
      "timestamp": "2023-03-03T23:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 6184,
      "timestamp": "2023-03-03T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 177898,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 168520,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 57961,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 44538,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 43489,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 39862,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 34159,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 25048,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 15545,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 13021,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 11327,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9596,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6481,
      "timestamp": "2023-03-04T00:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 6253,
      "timestamp": "2023-03-04T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 180055,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 169755,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 58187,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 44794,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 43973,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 40180,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 34191,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 25200,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 15600,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 13099,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 11342,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9610,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6490,
      "timestamp": "2023-03-04T01:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 6320,
      "timestamp": "2023-03-04T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 181411,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 170465,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 58230,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 45018,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 44192,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 40546,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 34344,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 25257,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 15609,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 13109,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 11365,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9611,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6541,
      "timestamp": "2023-03-04T02:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 6328,
      "timestamp": "2023-03-04T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 182121,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 170667,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 58279,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 45082,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 44447,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 41018,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 34363,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 25284,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 15617,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 13145,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 11381,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-04T03:00:00-05:00",
      "votes": 9611
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6548,
      "timestamp": "2023-03-04T03:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 6333,
      "timestamp": "2023-03-04T03:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 182984,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 171171,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 58290,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 45199,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 44612,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 41219,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 34391,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 25317,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 15721,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 13161,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 11391,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9613,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6553,
      "timestamp": "2023-03-04T04:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 6339,
      "timestamp": "2023-03-04T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 183793,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 171625,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 58526,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 45308,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 44830,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 41246,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 34467,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 25322,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 15929,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 13171,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 11405,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9616,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6558,
      "timestamp": "2023-03-04T05:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 6409,
      "timestamp": "2023-03-04T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 185252,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 172531,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 59379,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 45455,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 45179,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 41310,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 34548,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 25535,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 16013,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 13233,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 11433,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9625,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6590,
      "timestamp": "2023-03-04T06:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 6457,
      "timestamp": "2023-03-04T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 186686,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 173438,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 59580,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 45939,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 45639,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 41545,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 34749,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 25644,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 16168,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 13411,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 11576,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9638,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6669,
      "timestamp": "2023-03-04T07:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 6518,
      "timestamp": "2023-03-04T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 188839,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 174319,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 60007,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 46699,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 46108,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 41991,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 34962,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 26014,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 16393,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 13519,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 11748,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9733,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6838,
      "timestamp": "2023-03-04T08:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 6574,
      "timestamp": "2023-03-04T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 190600,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 176188,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 60360,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 47242,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 46510,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 42812,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 35186,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 26286,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 16597,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 13628,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 11858,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9790,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 6903,
      "timestamp": "2023-03-04T09:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 6891,
      "timestamp": "2023-03-04T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 192084,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 177214,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 60657,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 48026,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 46815,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 43244,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 35320,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 26489,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 16817,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 13686,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 12084,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9895,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 7068,
      "timestamp": "2023-03-04T10:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 7037,
      "timestamp": "2023-03-04T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 193655,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 178647,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 60907,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 48730,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 47011,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 43714,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 35483,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 26783,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 16915,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 13711,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 12487,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 9962,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 7306,
      "timestamp": "2023-03-04T11:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 7145,
      "timestamp": "2023-03-04T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 195217,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 179686,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 61364,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 49174,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 47487,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 44063,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 35682,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 27051,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 17051,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 13944,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 12998,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10106,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 7419,
      "timestamp": "2023-03-04T12:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 7191,
      "timestamp": "2023-03-04T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 197032,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 181579,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 61755,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 50041,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 47779,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 44391,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 36069,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 27351,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 17112,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 14244,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 13323,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10158,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 7802,
      "timestamp": "2023-03-04T13:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 7224,
      "timestamp": "2023-03-04T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 199441,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 183407,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 62085,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 50734,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 48105,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 44665,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 36259,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 27553,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 17283,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 14465,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 13662,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10181,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 8039,
      "timestamp": "2023-03-04T14:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 7262,
      "timestamp": "2023-03-04T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 201270,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 184615,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 62309,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 51338,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 48542,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 44818,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 36444,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 28175,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 17547,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 14681,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 14080,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10300,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 8180,
      "timestamp": "2023-03-04T15:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 7334,
      "timestamp": "2023-03-04T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 202709,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 185542,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 62978,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 51914,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 49040,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 45280,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 36887,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 28404,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 17753,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 14834,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 14734,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10394,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 8470,
      "timestamp": "2023-03-04T16:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 7401,
      "timestamp": "2023-03-04T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 203950,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 186452,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 63377,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 52837,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 49463,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 45551,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 37354,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 28893,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 18196,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 15886,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 15051,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10454,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 8701,
      "timestamp": "2023-03-04T17:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 7457,
      "timestamp": "2023-03-04T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 205202,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 187802,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 63888,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 53393,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 49833,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 45727,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 37523,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 29159,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 18344,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 16609,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 15178,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10471,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 8931,
      "timestamp": "2023-03-04T18:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 7534,
      "timestamp": "2023-03-04T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 206483,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 189589,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 64262,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 53918,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 50604,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 45963,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 37982,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 29383,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 18518,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 17263,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 15239,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10531,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 9283,
      "timestamp": "2023-03-04T19:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 7676,
      "timestamp": "2023-03-04T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 208124,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 191055,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 65133,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 54565,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 51011,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 46232,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 38312,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 29753,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 18699,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 17811,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 15426,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10607,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 9522,
      "timestamp": "2023-03-04T20:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 7815,
      "timestamp": "2023-03-04T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 210553,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 192721,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 65925,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 55208,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 51816,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 46588,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 38623,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 30002,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 18922,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 18466,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 15539,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10696,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 9799,
      "timestamp": "2023-03-04T21:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 7858,
      "timestamp": "2023-03-04T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 212359,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 194954,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 66147,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 56483,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 52712,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 46937,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 38878,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 30181,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 19243,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 19135,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 15687,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10778,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 10077,
      "timestamp": "2023-03-04T22:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 7974,
      "timestamp": "2023-03-04T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 213789,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 195912,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 66828,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 57021,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 53075,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 47153,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 39186,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 30380,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 19630,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 19208,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 15720,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10797,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 10486,
      "timestamp": "2023-03-04T23:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 8234,
      "timestamp": "2023-03-04T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 215217,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 196840,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 67302,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 57317,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 53337,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 47304,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 39416,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 30554,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 19909,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 19276,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 15748,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10810,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 10693,
      "timestamp": "2023-03-05T00:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 8332,
      "timestamp": "2023-03-05T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 216138,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 197650,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 68146,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 57638,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 53415,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 47469,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 39459,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 30573,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 20136,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 19287,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 15806,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10814,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 10794,
      "timestamp": "2023-03-05T01:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 8379,
      "timestamp": "2023-03-05T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 216547,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 197803,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 68209,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 57832,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 53473,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 47616,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 39498,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 30618,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 20299,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 19300,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 15816,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 10856,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10817,
      "timestamp": "2023-03-05T02:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 8385,
      "timestamp": "2023-03-05T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 217058,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 197906,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 68342,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 58076,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 53504,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 47675,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 39535,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 30628,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 20439,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 19544,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 15824,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 10860,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10819,
      "timestamp": "2023-03-05T03:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 8400,
      "timestamp": "2023-03-05T03:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 217605,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 197947,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 68550,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 58194,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 53525,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 47686,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 39543,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 30672,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 20613,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 19711,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 15825,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 10885,
      "timestamp": "2023-03-05T04:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-05T04:00:00-05:00",
      "votes": 10819
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 8416,
      "timestamp": "2023-03-05T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 218067,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 198206,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 68735,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 58230,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 53540,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 47709,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 39568,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 30785,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 21025,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 19858,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 15826,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 10942,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10830,
      "timestamp": "2023-03-05T05:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 8431,
      "timestamp": "2023-03-05T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 218544,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 198275,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 68805,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 58330,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 53588,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 47874,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 39648,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 30802,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 21168,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 19994,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 15830,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 11010,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10835,
      "timestamp": "2023-03-05T06:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 8459,
      "timestamp": "2023-03-05T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 219115,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 198477,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 69401,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 58621,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 53656,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 47921,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 39790,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 31021,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 21280,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 20235,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 15895,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 11144,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 10873,
      "timestamp": "2023-03-05T07:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 8503,
      "timestamp": "2023-03-05T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 219763,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 198937,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 70329,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 59141,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 53812,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 48057,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 40019,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 31193,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 21597,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 20547,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 16031,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 11192,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11059,
      "timestamp": "2023-03-05T08:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 8574,
      "timestamp": "2023-03-05T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 221036,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 199478,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 70614,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 59639,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 54049,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 48246,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 40174,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 31267,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 21911,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 20914,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 16072,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 11510,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11381,
      "timestamp": "2023-03-05T09:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 8622,
      "timestamp": "2023-03-05T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 222031,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 200116,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 70728,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 59906,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 54328,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 48519,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 40328,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 31361,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 22422,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 21172,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 16175,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 11735,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11407,
      "timestamp": "2023-03-05T10:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 8674,
      "timestamp": "2023-03-05T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 223080,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 200805,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 70963,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 60126,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 54674,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 48866,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 40575,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 31542,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 22704,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 21323,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 16225,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 12018,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11429,
      "timestamp": "2023-03-05T11:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 8788,
      "timestamp": "2023-03-05T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 224594,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 201597,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 71237,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 60561,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 55161,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 49084,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 40908,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 31662,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 23310,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 21463,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 16268,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 12231,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11478,
      "timestamp": "2023-03-05T12:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 8942,
      "timestamp": "2023-03-05T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 225687,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 202442,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 71661,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 60776,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 55431,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 49229,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 41294,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 31917,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 23775,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 21816,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 16304,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 12406,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11484,
      "timestamp": "2023-03-05T13:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 9090,
      "timestamp": "2023-03-05T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 226430,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 203743,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 71915,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 61091,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 55784,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 49465,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 41427,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 32234,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 24065,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 22011,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 16399,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 12543,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11523,
      "timestamp": "2023-03-05T14:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 9218,
      "timestamp": "2023-03-05T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 227664,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 205017,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 72081,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 61578,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 55997,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 49632,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 41668,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 32430,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 24647,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 22282,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 16455,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 12637,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11537,
      "timestamp": "2023-03-05T15:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 9250,
      "timestamp": "2023-03-05T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 228905,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 205996,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 72267,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 62231,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 56288,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 49916,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 41809,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 32729,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 25052,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 22556,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 16526,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 12892,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11570,
      "timestamp": "2023-03-05T16:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 9354,
      "timestamp": "2023-03-05T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 230432,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 207198,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 72645,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 62952,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 56700,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 50203,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 42177,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 32982,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 25520,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 22752,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 16560,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 13190,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11584,
      "timestamp": "2023-03-05T17:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 9391,
      "timestamp": "2023-03-05T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 231368,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 208747,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 73928,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 63428,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 57085,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 50460,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 42489,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 33232,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 26013,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 23006,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 16621,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 13420,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11605,
      "timestamp": "2023-03-05T18:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 9408,
      "timestamp": "2023-03-05T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 232440,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 210068,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 74479,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 64393,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 57534,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 51051,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 42857,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 33731,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 26441,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 23122,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 16719,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 13624,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11650,
      "timestamp": "2023-03-05T19:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 9471,
      "timestamp": "2023-03-05T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 233832,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 211584,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 75039,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 64961,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 58149,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 51413,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 43148,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 34014,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 26922,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 23288,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 16768,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 13910,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11675,
      "timestamp": "2023-03-05T20:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 9587,
      "timestamp": "2023-03-05T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 235682,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 213199,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 76057,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 65545,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 58624,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 51912,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 43508,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 34370,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 27525,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 23480,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 16880,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 14552,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11736,
      "timestamp": "2023-03-05T21:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 9659,
      "timestamp": "2023-03-05T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 237365,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 215249,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 76750,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 66086,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 59406,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 52207,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 43710,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 34644,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 27868,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 23617,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17047,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 14907,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11743,
      "timestamp": "2023-03-05T22:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 9836,
      "timestamp": "2023-03-05T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 238611,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 216291,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 77316,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 66581,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 59928,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 52523,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 43892,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 34933,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 28205,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 23840,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17135,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 15215,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11750,
      "timestamp": "2023-03-05T23:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 9893,
      "timestamp": "2023-03-05T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 239674,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 217797,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 78412,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 66757,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 60182,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 52775,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 43934,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 35072,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 28502,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 23989,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17366,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 15490,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11779,
      "timestamp": "2023-03-06T00:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 9927,
      "timestamp": "2023-03-06T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 240271,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 218525,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 78725,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 67270,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 60417,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 53008,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 44051,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 35124,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 28594,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 24023,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17402,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 15576,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11782,
      "timestamp": "2023-03-06T01:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 9940,
      "timestamp": "2023-03-06T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 240752,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 218852,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 78855,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 67457,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 60468,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 53144,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 44079,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 35126,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 28613,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 24073,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17431,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 15607,
      "timestamp": "2023-03-06T02:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-06T02:00:00-05:00",
      "votes": 11782
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 9945,
      "timestamp": "2023-03-06T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 241132,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 219217,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 79078,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 67640,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 60534,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 53418,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 44103,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 35203,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 28722,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 24470,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17434,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 15641,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11783,
      "timestamp": "2023-03-06T03:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 9946,
      "timestamp": "2023-03-06T03:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 241470,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 219305,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 79159,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 67746,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 60539,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 53653,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 44183,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 35236,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 28776,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 24488,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17438,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 15647,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11786,
      "timestamp": "2023-03-06T04:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 9948,
      "timestamp": "2023-03-06T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 242069,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 219987,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 79458,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 67809,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 60546,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 53679,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 44220,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 35254,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 28791,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 24523,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17445,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 15743,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11788,
      "timestamp": "2023-03-06T05:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 10005,
      "timestamp": "2023-03-06T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 242703,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 220779,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 80213,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 67937,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 60646,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 53792,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 44280,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 35362,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 28991,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 24688,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17511,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 15884,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11820,
      "timestamp": "2023-03-06T06:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 10028,
      "timestamp": "2023-03-06T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 243599,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 221178,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 80645,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 68388,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 60938,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 54050,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 44876,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 35667,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 29306,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 24876,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17530,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 15986,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11841,
      "timestamp": "2023-03-06T07:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 10062,
      "timestamp": "2023-03-06T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 244298,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 222513,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 81260,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 68756,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 61104,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 54273,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 45137,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 35892,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 29578,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 25144,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17550,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 16112,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11878,
      "timestamp": "2023-03-06T08:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 10163,
      "timestamp": "2023-03-06T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 245374,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 223875,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 81654,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 69137,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 61339,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 54496,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 45551,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 36107,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 30005,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 25301,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17570,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 16260,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11910,
      "timestamp": "2023-03-06T09:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 10213,
      "timestamp": "2023-03-06T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 246224,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 225564,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 81881,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 69608,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 61619,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 54850,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 45770,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 36257,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 30291,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 25428,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17611,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 16438,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 11975,
      "timestamp": "2023-03-06T10:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 10252,
      "timestamp": "2023-03-06T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 247187,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 226540,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 82094,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 70112,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 61794,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 55135,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 46078,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 36517,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 30488,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 25511,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17638,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 16711,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12011,
      "timestamp": "2023-03-06T11:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 10298,
      "timestamp": "2023-03-06T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 248491,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 228157,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 82334,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 70528,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 62050,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 55374,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 46410,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 36739,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 30881,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 25626,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17660,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 16859,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12027,
      "timestamp": "2023-03-06T12:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 10337,
      "timestamp": "2023-03-06T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 249813,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 229692,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 82854,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 71177,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 62526,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 55538,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 46750,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 36955,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 31160,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 25731,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17753,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 17004,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12075,
      "timestamp": "2023-03-06T13:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 10360,
      "timestamp": "2023-03-06T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 251533,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 231254,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 83187,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 71895,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 62714,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 55927,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 46932,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 37274,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 31453,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 25861,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17790,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 17215,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12135,
      "timestamp": "2023-03-06T14:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 10400,
      "timestamp": "2023-03-06T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 253288,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 233037,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 83480,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 72475,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 62897,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 56265,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 47296,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 37611,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 32034,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 26005,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17862,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 17431,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12189,
      "timestamp": "2023-03-06T15:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 10503,
      "timestamp": "2023-03-06T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 254569,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 234495,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 84288,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 73017,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 63439,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 56480,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 47495,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 37822,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 32540,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 26243,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17895,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 17657,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12358,
      "timestamp": "2023-03-06T16:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 10575,
      "timestamp": "2023-03-06T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 256840,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 236347,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 84958,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 73369,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 64038,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 56926,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 47944,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 38069,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 32870,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 26570,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 17995,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 17973,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12413,
      "timestamp": "2023-03-06T17:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 10678,
      "timestamp": "2023-03-06T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 259156,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 237467,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 85317,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 74140,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 64702,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 57377,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 48374,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 38359,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 33312,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 26838,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 18273,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18045,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12526,
      "timestamp": "2023-03-06T18:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 10774,
      "timestamp": "2023-03-06T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 260486,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 239370,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 86338,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 74896,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 65181,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 57782,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 48787,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 38729,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 33835,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 27068,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 18511,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18192,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12593,
      "timestamp": "2023-03-06T19:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 10976,
      "timestamp": "2023-03-06T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 262438,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 240705,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 86928,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 75475,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 66047,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 58267,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 49516,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 39049,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 34263,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 27228,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 18821,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18236,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12666,
      "timestamp": "2023-03-06T20:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 11303,
      "timestamp": "2023-03-06T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 263849,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 241982,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 87986,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 76116,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 66673,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 58564,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 50040,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 39496,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 34835,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 27376,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 19461,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18309,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12723,
      "timestamp": "2023-03-06T21:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 11433,
      "timestamp": "2023-03-06T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 265569,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 243394,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 88640,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 76565,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 67213,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 59079,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 50419,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 40339,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 35225,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 27553,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 20207,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18378,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12749,
      "timestamp": "2023-03-06T22:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 11594,
      "timestamp": "2023-03-06T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 266693,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 244120,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 89337,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 77073,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 67825,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 59690,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 50749,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 40482,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 35466,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 27593,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 20614,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18408,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12774,
      "timestamp": "2023-03-06T23:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 11768,
      "timestamp": "2023-03-06T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 267858,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 245425,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 89384,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 77519,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 68014,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 60121,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 51142,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 40552,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 35585,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 27648,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 20736,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18438,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12780,
      "timestamp": "2023-03-07T00:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 11949,
      "timestamp": "2023-03-07T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 268321,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 245928,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 89510,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 77693,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 68293,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 60292,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 51201,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 40576,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 35635,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 27656,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 20831,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18496,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12789,
      "timestamp": "2023-03-07T01:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 11981,
      "timestamp": "2023-03-07T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 268673,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 246047,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 89622,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 77756,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 68362,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 60367,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 51216,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 40605,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 35779,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 27667,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 20848,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18515,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12795,
      "timestamp": "2023-03-07T02:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 12052,
      "timestamp": "2023-03-07T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 269289,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 246160,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 89660,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 77790,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 68498,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 60659,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 51289,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 40640,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 35852,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 27672,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 20875,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18521,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12808,
      "timestamp": "2023-03-07T03:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 12058,
      "timestamp": "2023-03-07T03:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 269686,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 246315,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 89770,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 77937,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 68510,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 60807,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 51357,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 40840,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 36178,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 27677,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 20898,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18547,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12817,
      "timestamp": "2023-03-07T04:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 12093,
      "timestamp": "2023-03-07T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 270245,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 246587,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 89895,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 78182,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 68669,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 60812,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 51387,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 41057,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 36323,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 27724,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 20958,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18551,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12864,
      "timestamp": "2023-03-07T05:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 12155,
      "timestamp": "2023-03-07T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 270673,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 247541,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 90880,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 78324,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 68798,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 61048,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 51445,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 41265,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 36565,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 27827,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 21151,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18567,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12915,
      "timestamp": "2023-03-07T06:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 12191,
      "timestamp": "2023-03-07T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 271252,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 248536,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 91307,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 78592,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 68918,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 61123,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 51566,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 41612,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 36755,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 28142,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 21223,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18600,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 12953,
      "timestamp": "2023-03-07T07:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 12284,
      "timestamp": "2023-03-07T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 271904,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 249722,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 91930,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 78851,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 69128,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 61405,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 51783,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 41841,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 37267,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 28624,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 21393,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18621,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 13028,
      "timestamp": "2023-03-07T08:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 12421,
      "timestamp": "2023-03-07T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 272803,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 251108,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 92400,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 79404,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 69612,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 61899,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 51975,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 42068,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 37602,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 28869,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 21725,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18662,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 13090,
      "timestamp": "2023-03-07T09:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 12526,
      "timestamp": "2023-03-07T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 273972,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 252183,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 93613,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 79945,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 70113,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 62310,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 52206,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 42234,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 37962,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 29083,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 21854,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 18822,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 13133,
      "timestamp": "2023-03-07T10:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 12591,
      "timestamp": "2023-03-07T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 274795,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 253199,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 94205,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 80470,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 70578,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 62764,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 52495,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 42457,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 38325,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 29402,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 22136,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 19016,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 13195,
      "timestamp": "2023-03-07T11:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 12720,
      "timestamp": "2023-03-07T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 276092,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 254660,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 94840,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 81249,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 71139,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 63215,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 52765,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 42715,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 38618,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 29857,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 22323,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 19244,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 13275,
      "timestamp": "2023-03-07T12:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 13069,
      "timestamp": "2023-03-07T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 277112,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 256886,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 95937,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 82033,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 71558,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 63560,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 52954,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 43069,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 38874,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 30279,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 22451,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 19360,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 13421,
      "timestamp": "2023-03-07T13:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 13204,
      "timestamp": "2023-03-07T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 280010,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 260143,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 96442,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 82427,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 71922,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 63798,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 53425,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 43897,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 39251,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 30542,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 22649,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 19481,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 13500,
      "timestamp": "2023-03-07T14:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 13353,
      "timestamp": "2023-03-07T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 282130,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 261920,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 97346,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 82859,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 72408,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 64072,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 53736,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 44457,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 39579,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 30847,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 22830,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 19572,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 13652,
      "timestamp": "2023-03-07T15:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 13547,
      "timestamp": "2023-03-07T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 283739,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 263333,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 98162,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 83395,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 72864,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 64517,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 54369,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 44992,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 39872,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 31376,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 23261,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 19645,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 13942,
      "timestamp": "2023-03-07T16:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 13644,
      "timestamp": "2023-03-07T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 285138,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 264235,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 98772,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 83622,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 73136,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 64832,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 54674,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 45376,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 40211,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 31718,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 23894,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 19762,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 14178,
      "timestamp": "2023-03-07T17:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 13670,
      "timestamp": "2023-03-07T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 286769,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 265405,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 99141,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 83978,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 73749,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 65062,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 54878,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 45822,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 40913,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 32027,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 24091,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 19923,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 14397,
      "timestamp": "2023-03-07T18:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 13712,
      "timestamp": "2023-03-07T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 288897,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 267212,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 100315,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 84478,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 74432,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 65318,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 55140,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 46344,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 41359,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 32283,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 24485,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 20178,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 14611,
      "timestamp": "2023-03-07T19:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 13773,
      "timestamp": "2023-03-07T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 290877,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 269180,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 102079,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 85059,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 75305,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 65648,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 55647,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 46703,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 41757,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 32717,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 24816,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 20547,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 14969,
      "timestamp": "2023-03-07T20:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 13859,
      "timestamp": "2023-03-07T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 293249,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 270813,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 103214,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 85866,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 75811,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 66106,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 56150,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 47198,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 42265,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 33068,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 25197,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 20847,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 15400,
      "timestamp": "2023-03-07T21:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 13942,
      "timestamp": "2023-03-07T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 296018,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 272715,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 103946,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 86487,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 76102,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 66312,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 56572,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 47871,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 42497,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 33346,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 25637,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 21432,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 15737,
      "timestamp": "2023-03-07T22:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 13989,
      "timestamp": "2023-03-07T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 298230,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 274345,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 104688,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 86813,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 76289,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 66737,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 57123,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 48068,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 42583,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 33537,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 25966,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 21530,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 15993,
      "timestamp": "2023-03-07T23:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14060,
      "timestamp": "2023-03-07T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 299748,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 275586,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 105638,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 87050,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 76668,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 67068,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 57218,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 48178,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 42651,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 33641,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 26122,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 21582,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 16174,
      "timestamp": "2023-03-08T00:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14064,
      "timestamp": "2023-03-08T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 300516,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 276388,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 105965,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 87320,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 76869,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 67297,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 57331,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 48261,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 42792,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 33782,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 26210,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 21633,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 16211,
      "timestamp": "2023-03-08T01:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14072,
      "timestamp": "2023-03-08T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 301151,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 276631,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 106127,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 87490,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 76962,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 67374,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 57473,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 48287,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 42880,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 34002,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 26221,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 21666,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 16309,
      "timestamp": "2023-03-08T02:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14076,
      "timestamp": "2023-03-08T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 301530,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 276773,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 106222,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 87618,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 77144,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 67406,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 57569,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 48366,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 42943,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 34240,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 26240,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 21701,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 16320,
      "timestamp": "2023-03-08T03:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14079,
      "timestamp": "2023-03-08T03:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 301940,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 276953,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 106607,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 87691,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 77214,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 67425,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 57596,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 48529,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 43117,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 34417,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 26324,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 21706,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 16328,
      "timestamp": "2023-03-08T04:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14080,
      "timestamp": "2023-03-08T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 302509,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 277244,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 106830,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 87766,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 77227,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 67580,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 57619,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 48558,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 43423,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 34503,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 26504,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 21716,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 16409,
      "timestamp": "2023-03-08T05:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14087,
      "timestamp": "2023-03-08T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 303339,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 278170,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 107398,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 87921,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 77281,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 67724,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 57781,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 48702,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 43683,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 34633,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 26642,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 21905,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 16575,
      "timestamp": "2023-03-08T06:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14096,
      "timestamp": "2023-03-08T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 304322,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 279137,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 108246,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 88060,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 77401,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 67829,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 58018,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 49161,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 43945,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 34964,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 26849,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 22262,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 16675,
      "timestamp": "2023-03-08T07:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14122,
      "timestamp": "2023-03-08T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 305263,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 279706,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 109207,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 88499,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 77642,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 68082,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 58235,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 49413,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 44164,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 35120,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 27013,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 23027,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 16760,
      "timestamp": "2023-03-08T08:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14162,
      "timestamp": "2023-03-08T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 306165,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 280757,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 109965,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 88961,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 77922,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 68354,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 58442,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 49643,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 44432,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 35232,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 27202,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 23287,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 16899,
      "timestamp": "2023-03-08T09:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14212,
      "timestamp": "2023-03-08T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 307232,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 281831,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 110653,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 89374,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 78197,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 69103,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 58601,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 50099,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 44598,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 35381,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 27449,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 23544,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 17046,
      "timestamp": "2023-03-08T10:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14246,
      "timestamp": "2023-03-08T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 308005,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 283412,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 111848,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 89786,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 78476,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 69388,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 58778,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 50417,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 44961,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 35595,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 27749,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 23822,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 17155,
      "timestamp": "2023-03-08T11:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14313,
      "timestamp": "2023-03-08T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 308792,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 284617,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 112497,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 90018,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 78630,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 69792,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 59207,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 50874,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 45182,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 35831,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 28049,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 23984,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 17273,
      "timestamp": "2023-03-08T12:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14337,
      "timestamp": "2023-03-08T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 310007,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 285888,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 113292,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 90308,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 78783,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 69951,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 59432,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 51299,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 45282,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 36045,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 28175,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 24190,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 17513,
      "timestamp": "2023-03-08T13:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14345,
      "timestamp": "2023-03-08T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 311384,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 287337,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 113916,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 90573,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 78983,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 70169,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 59745,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 51588,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 45472,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 36248,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 28364,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 24349,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 17645,
      "timestamp": "2023-03-08T14:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14403,
      "timestamp": "2023-03-08T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 312735,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 288566,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 114474,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 90918,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 79171,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 70354,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 59976,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 52059,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 45651,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 36541,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 28551,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 24521,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 17758,
      "timestamp": "2023-03-08T15:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14441,
      "timestamp": "2023-03-08T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 313944,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 290080,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 115454,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 91536,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 79570,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 70542,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 60176,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 52344,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 45884,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 36806,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 28790,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 24882,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 17928,
      "timestamp": "2023-03-08T16:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14460,
      "timestamp": "2023-03-08T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 315382,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 291345,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 115993,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 92156,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 79964,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 70876,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 60354,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 52707,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 46227,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 37055,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 29079,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 25354,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 18068,
      "timestamp": "2023-03-08T17:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14535,
      "timestamp": "2023-03-08T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 316463,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 292581,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 116691,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 92684,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 80302,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 71176,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 60687,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 53149,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 46640,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 37537,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 29312,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 25701,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 18182,
      "timestamp": "2023-03-08T18:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14566,
      "timestamp": "2023-03-08T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 318425,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 294397,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 117463,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 93241,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 80827,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 71467,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 60900,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 53493,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 46929,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 37974,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 29597,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 26096,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 18394,
      "timestamp": "2023-03-08T19:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14603,
      "timestamp": "2023-03-08T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 320530,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 295998,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 118580,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 94067,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 81117,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 71867,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 61349,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 53956,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 47260,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 38520,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 30040,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 26383,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 18566,
      "timestamp": "2023-03-08T20:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14694,
      "timestamp": "2023-03-08T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 322270,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 297358,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 119334,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 94754,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 81615,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 72078,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 61795,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 54582,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 47591,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 39140,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 30470,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 26573,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 18760,
      "timestamp": "2023-03-08T21:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14721,
      "timestamp": "2023-03-08T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 324716,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 299485,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 120355,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 95045,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 82093,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 72588,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 62385,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 54880,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 47955,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 39590,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 31120,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 26871,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 18862,
      "timestamp": "2023-03-08T22:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14802,
      "timestamp": "2023-03-08T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 326255,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 300825,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 120938,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 95204,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 82361,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 72853,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 62725,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 55041,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 48144,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 40002,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 31390,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 27065,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 19043,
      "timestamp": "2023-03-08T23:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14930,
      "timestamp": "2023-03-08T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 327532,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 302031,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 121376,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 95306,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 82465,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 73172,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 62888,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 55084,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 48206,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 40233,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 31766,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 27222,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 19182,
      "timestamp": "2023-03-09T00:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14946,
      "timestamp": "2023-03-09T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 328334,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 302697,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 121676,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 95394,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 82600,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 73352,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 62986,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 55115,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 48218,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 40394,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 31901,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 27252,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 19311,
      "timestamp": "2023-03-09T01:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14949,
      "timestamp": "2023-03-09T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 328985,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 302788,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 121784,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 95499,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 82619,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 73473,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 63103,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 55166,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 48224,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 40533,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 31920,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 27421,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 19336,
      "timestamp": "2023-03-09T02:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14951,
      "timestamp": "2023-03-09T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 329676,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 302824,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 121909,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 95657,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 82704,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 73500,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 63220,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 55178,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 48244,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 40556,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 31933,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 27540,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 19349,
      "timestamp": "2023-03-09T03:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14953,
      "timestamp": "2023-03-09T03:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 330612,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 303165,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 121929,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 95933,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 82717,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 73672,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 63321,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 55252,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 48304,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 40620,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 31942,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 27552,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 19355,
      "timestamp": "2023-03-09T04:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14954,
      "timestamp": "2023-03-09T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 331581,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 303401,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 122350,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 96022,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 82782,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 73853,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 63402,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 55361,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 48342,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 40825,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 32089,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 27612,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 19372,
      "timestamp": "2023-03-09T05:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14958,
      "timestamp": "2023-03-09T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 332158,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 304211,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 123008,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 96101,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 82853,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 73958,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 63552,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 55626,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 48390,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 41015,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 32232,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 27683,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 19417,
      "timestamp": "2023-03-09T06:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 14959,
      "timestamp": "2023-03-09T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 332947,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 304849,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 123263,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 96276,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 82886,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 74065,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 63774,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 56041,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 48560,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 41151,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 32302,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 27814,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 19452,
      "timestamp": "2023-03-09T07:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 15072,
      "timestamp": "2023-03-09T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 334200,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 306406,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 123737,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 96623,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 82977,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 74288,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 64064,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 56458,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 48897,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 41405,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 32408,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 28119,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 19502,
      "timestamp": "2023-03-09T08:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 15170,
      "timestamp": "2023-03-09T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 335190,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 307491,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 124566,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 97051,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 83177,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 74564,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 64137,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 56680,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 49421,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 41883,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 32511,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 28538,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 19582,
      "timestamp": "2023-03-09T09:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 15224,
      "timestamp": "2023-03-09T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 336231,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 308922,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 125065,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 97503,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 83344,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 75085,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 64256,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 56898,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 49780,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 42163,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 32778,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 29054,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 19664,
      "timestamp": "2023-03-09T10:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 15274,
      "timestamp": "2023-03-09T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 337112,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 310341,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 125575,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 97924,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 83617,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 75682,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 64513,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 57438,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 50343,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 42524,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 33233,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 30771,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 19791,
      "timestamp": "2023-03-09T11:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 15301,
      "timestamp": "2023-03-09T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 338107,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 312545,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 126159,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 98519,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 83839,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 76117,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 64713,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 57830,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 50688,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 42927,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 33401,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 31730,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 19881,
      "timestamp": "2023-03-09T12:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 15375,
      "timestamp": "2023-03-09T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 338956,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 314487,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 126477,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 98973,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 83952,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 76381,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 65095,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 58177,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 51206,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 43331,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 33627,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 32317,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 20014,
      "timestamp": "2023-03-09T13:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 15503,
      "timestamp": "2023-03-09T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 340595,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 316057,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 126920,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 99478,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 84221,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 77009,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 65368,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 58476,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 51412,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 43773,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 33778,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 33043,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 20064,
      "timestamp": "2023-03-09T14:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 15609,
      "timestamp": "2023-03-09T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 342439,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 317692,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 127327,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 99839,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 84336,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 77269,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 65664,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 58826,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 51740,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 44211,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 34008,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 33819,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 20132,
      "timestamp": "2023-03-09T15:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 15689,
      "timestamp": "2023-03-09T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 344253,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 319035,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 127862,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 100274,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 84699,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 77644,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 66009,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 59327,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 51989,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 44737,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 34928,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 34181,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 20180,
      "timestamp": "2023-03-09T16:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 15719,
      "timestamp": "2023-03-09T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 345867,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 320321,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 128330,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 100720,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 85104,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 78041,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 66407,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 59715,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 52288,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 45059,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 35664,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 34625,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 20340,
      "timestamp": "2023-03-09T17:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 15734,
      "timestamp": "2023-03-09T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 348026,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 321550,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 128843,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 101173,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 85623,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 78641,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 66637,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 60090,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 52765,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 45363,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 36922,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 34813,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 20418,
      "timestamp": "2023-03-09T18:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 15792,
      "timestamp": "2023-03-09T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 350486,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 323098,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 129778,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 101698,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 85852,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 79163,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 67413,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 60506,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 53132,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 45735,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 38365,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 35215,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 20490,
      "timestamp": "2023-03-09T19:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 15859,
      "timestamp": "2023-03-09T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 352110,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 325312,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 131258,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 102186,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 86172,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 79482,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 68255,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 61061,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 53512,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 46313,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 39274,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 35503,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 20577,
      "timestamp": "2023-03-09T20:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 15940,
      "timestamp": "2023-03-09T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 353520,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 326861,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 132464,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 102732,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 86489,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 79928,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 68803,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 61424,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 53929,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 46631,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 40442,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 35831,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 20712,
      "timestamp": "2023-03-09T21:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 15965,
      "timestamp": "2023-03-09T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 354555,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 327996,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 133802,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 103051,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 86899,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 80365,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 69163,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 61786,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 54176,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 46889,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 41610,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 36380,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 20793,
      "timestamp": "2023-03-09T22:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16021,
      "timestamp": "2023-03-09T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 355693,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 329665,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 134496,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 103196,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 87535,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 80812,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 69360,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 62119,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 54417,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 47229,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 42555,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 36544,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 20923,
      "timestamp": "2023-03-09T23:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16048,
      "timestamp": "2023-03-09T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 356366,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 330678,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 134601,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 103404,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 87882,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 81185,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 69770,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 62172,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 54493,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 47298,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 43434,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 36669,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21030,
      "timestamp": "2023-03-10T00:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16058,
      "timestamp": "2023-03-10T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 356665,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 331765,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 134935,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 103461,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 88245,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 81441,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 70056,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 62195,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 54549,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 47476,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 43764,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 36800,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21101,
      "timestamp": "2023-03-10T01:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16061,
      "timestamp": "2023-03-10T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 356933,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 332217,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 135128,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 103532,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 88352,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 82027,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 70091,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 62305,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 54561,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 47499,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 44000,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 36887,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21114,
      "timestamp": "2023-03-10T02:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16074,
      "timestamp": "2023-03-10T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 357279,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 332408,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 135205,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 103563,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 88482,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 82319,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 70144,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 62395,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 54577,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 47549,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 44036,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 36912,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21127,
      "timestamp": "2023-03-10T03:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16110,
      "timestamp": "2023-03-10T03:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 357678,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 332528,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 135223,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 103566,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 88527,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 82451,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 70269,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 62444,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 54600,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 47562,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 44343,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 36918,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21133,
      "timestamp": "2023-03-10T04:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16115,
      "timestamp": "2023-03-10T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 358157,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 332889,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 135379,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 103653,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 88535,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 82562,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 70337,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 62485,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 54664,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 47689,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 44686,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 36956,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21141,
      "timestamp": "2023-03-10T05:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16118,
      "timestamp": "2023-03-10T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 358621,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 333681,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 136089,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 103829,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 88806,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 82686,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 70585,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 62518,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 54975,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 47783,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 45352,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 37101,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21166,
      "timestamp": "2023-03-10T06:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16132,
      "timestamp": "2023-03-10T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 359380,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 334430,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 136367,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 104120,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 89104,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 82840,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 70904,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 62771,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 55218,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 47945,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 46158,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 37257,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21244,
      "timestamp": "2023-03-10T07:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16168,
      "timestamp": "2023-03-10T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 360282,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 335465,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 137136,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 104431,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 89385,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 83207,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 71094,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 62994,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 55452,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 48254,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 47156,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 37357,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21349,
      "timestamp": "2023-03-10T08:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16222,
      "timestamp": "2023-03-10T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 361155,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 337313,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 138152,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 104865,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 89694,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 83557,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 71505,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 63202,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 55520,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 48481,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 48099,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 37570,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21407,
      "timestamp": "2023-03-10T09:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16226,
      "timestamp": "2023-03-10T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 362531,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 338474,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 138816,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 105112,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 89939,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 83917,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 71748,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 63563,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 55682,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 49840,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 49186,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 37753,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21474,
      "timestamp": "2023-03-10T10:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16270,
      "timestamp": "2023-03-10T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 363283,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 340013,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 139520,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 105424,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 90272,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 84450,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 71969,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 63835,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 55972,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 51160,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 49659,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 37858,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21571,
      "timestamp": "2023-03-10T11:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16290,
      "timestamp": "2023-03-10T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 364069,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 341237,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 140383,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 105759,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 90618,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 84933,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 72366,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 64044,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 56121,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 52169,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 50377,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 38002,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21619,
      "timestamp": "2023-03-10T12:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16372,
      "timestamp": "2023-03-10T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 364862,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 342534,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 141162,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 106037,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 90954,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 85612,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 72826,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 64369,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 56468,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 53036,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 50695,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 38197,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21715,
      "timestamp": "2023-03-10T13:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16511,
      "timestamp": "2023-03-10T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 365647,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 343663,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 141837,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 106265,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 91238,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 86290,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 73069,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 64944,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 56757,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 53756,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 51284,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 38519,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21760,
      "timestamp": "2023-03-10T14:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16567,
      "timestamp": "2023-03-10T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 367068,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 345157,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 143134,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 106522,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 91609,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 87227,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 73224,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 65284,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 57158,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 54887,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 51719,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 38696,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21800,
      "timestamp": "2023-03-10T15:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16608,
      "timestamp": "2023-03-10T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 368531,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 346489,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 144492,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 106892,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 92084,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 87555,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 73344,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 65543,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 57648,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 56001,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 52187,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 38883,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21882,
      "timestamp": "2023-03-10T16:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16626,
      "timestamp": "2023-03-10T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 370214,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 347607,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 145161,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 107279,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 92593,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 88036,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 73591,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 65923,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 58372,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 57377,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 52699,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 39014,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 21948,
      "timestamp": "2023-03-10T17:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16639,
      "timestamp": "2023-03-10T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 371453,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 348339,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 145809,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 107708,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 93146,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 88324,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 73805,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 66297,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 59172,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 58850,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 53287,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 39275,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 22013,
      "timestamp": "2023-03-10T18:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16671,
      "timestamp": "2023-03-10T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 372958,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 351538,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 146525,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 108048,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 93666,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 88875,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 74060,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 66848,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 61276,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 59609,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 53863,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 39395,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 22124,
      "timestamp": "2023-03-10T19:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16737,
      "timestamp": "2023-03-10T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 375428,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 354612,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 147305,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 108368,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 94173,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 89422,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 74406,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 67278,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 62871,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 60479,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 54438,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 39641,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 22222,
      "timestamp": "2023-03-10T20:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16803,
      "timestamp": "2023-03-10T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 377484,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 356188,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 148056,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 108796,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 94867,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 90078,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 74783,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 67730,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 64791,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 60949,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 55159,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 39989,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 22290,
      "timestamp": "2023-03-10T21:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16862,
      "timestamp": "2023-03-10T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 379119,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 358344,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 149325,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 109259,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 95318,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 91098,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 75300,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 68224,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 66961,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 61078,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 55598,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 40222,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 22357,
      "timestamp": "2023-03-10T22:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16888,
      "timestamp": "2023-03-10T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 380897,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 360680,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 150070,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 109557,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 95549,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 91663,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 75435,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 69302,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 68708,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 61336,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 56142,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 40405,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 22410,
      "timestamp": "2023-03-10T23:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16907,
      "timestamp": "2023-03-10T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 382314,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 361679,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 150484,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 110045,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 95786,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 92241,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 75618,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 70898,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 69305,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 61664,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 56422,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 40538,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 22451,
      "timestamp": "2023-03-11T00:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16941,
      "timestamp": "2023-03-11T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 383175,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 362248,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 150603,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 110141,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 95920,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 92480,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 75918,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 72145,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 69479,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 61745,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 56603,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 40622,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 22508,
      "timestamp": "2023-03-11T01:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16943,
      "timestamp": "2023-03-11T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 383733,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 362699,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 150951,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 110240,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 96083,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 92714,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 76019,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 72997,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 69558,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 61822,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 56746,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 40646,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 22617,
      "timestamp": "2023-03-11T02:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16948,
      "timestamp": "2023-03-11T02:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 384217,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 362740,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 151234,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 110419,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 96278,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 92868,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 76154,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 73773,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 69662,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 61871,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 56803,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 40668,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 22711,
      "timestamp": "2023-03-11T03:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16949,
      "timestamp": "2023-03-11T03:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 384693,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 362783,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 151288,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 110643,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 96609,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 93042,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 76325,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 74137,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 69744,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 61957,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 56823,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 40672,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 22718,
      "timestamp": "2023-03-11T04:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16952,
      "timestamp": "2023-03-11T04:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 385154,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 362963,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 151330,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 110800,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 96839,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 93123,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 76373,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 74557,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 69749,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 62165,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 56855,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 40720,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 22724,
      "timestamp": "2023-03-11T05:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16956,
      "timestamp": "2023-03-11T05:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 385827,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 364100,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 151504,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 111032,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 97057,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 93180,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 76611,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 75331,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 69906,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 62381,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 57144,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 40772,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 22762,
      "timestamp": "2023-03-11T06:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16960,
      "timestamp": "2023-03-11T06:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 386842,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 364820,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 151950,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 111239,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 97288,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 93433,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 77006,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 76347,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 70563,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 62571,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 57429,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 40896,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 22786,
      "timestamp": "2023-03-11T07:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 16962,
      "timestamp": "2023-03-11T07:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 388237,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 365765,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 152512,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 111486,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 97630,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 93654,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 78952,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 77472,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 71026,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 63124,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 57755,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 41000,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 22859,
      "timestamp": "2023-03-11T08:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17006,
      "timestamp": "2023-03-11T08:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 389774,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 367058,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 153092,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 111701,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 97844,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 94033,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 80177,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 77738,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 71344,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 63413,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 58003,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 41121,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 23078,
      "timestamp": "2023-03-11T09:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17013,
      "timestamp": "2023-03-11T09:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 391570,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 368460,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 153678,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 112231,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 98205,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 94558,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 81514,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 78485,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 71768,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 63879,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 58295,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 41274,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 23169,
      "timestamp": "2023-03-11T10:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17023,
      "timestamp": "2023-03-11T10:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 392870,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 369340,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 154473,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 112723,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 98358,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 94987,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 83235,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 79520,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 72118,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 64050,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 58545,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 41567,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 23230,
      "timestamp": "2023-03-11T11:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17053,
      "timestamp": "2023-03-11T11:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 393976,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 370177,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 156140,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 112957,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 98661,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 95800,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 84537,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 80414,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 72489,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 64279,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 58810,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 41711,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 23300,
      "timestamp": "2023-03-11T12:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17071,
      "timestamp": "2023-03-11T12:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 394598,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 370937,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 156938,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 113523,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 98887,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 96803,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 85947,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 80949,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 73002,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 64727,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 59052,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 41906,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 23382,
      "timestamp": "2023-03-11T13:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17080,
      "timestamp": "2023-03-11T13:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 395417,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 371995,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 157425,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 113724,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 99626,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 97624,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 86791,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 81506,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 73440,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 65167,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 59257,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 41998,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 23466,
      "timestamp": "2023-03-11T14:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17113,
      "timestamp": "2023-03-11T14:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 397211,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 372901,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 158426,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 114022,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 100375,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 98401,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 88210,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 82167,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 73807,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 65528,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 59473,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 42077,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 23513,
      "timestamp": "2023-03-11T15:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17135,
      "timestamp": "2023-03-11T15:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 398586,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 374142,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 159456,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 114277,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 100907,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 99218,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 89985,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 83029,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 74285,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 65946,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 60022,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 42231,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 23564,
      "timestamp": "2023-03-11T16:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17167,
      "timestamp": "2023-03-11T16:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 400409,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 375239,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 160165,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 114612,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 101272,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 100149,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 91601,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 83937,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 75074,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 66436,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 60287,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 42346,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 23637,
      "timestamp": "2023-03-11T17:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17173,
      "timestamp": "2023-03-11T17:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 402219,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 377338,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 161035,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 114954,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 101660,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 100998,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 93331,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 84845,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 75390,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 66747,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 60794,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 42443,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 23702,
      "timestamp": "2023-03-11T18:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17182,
      "timestamp": "2023-03-11T18:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 404129,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 379451,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 161970,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 115399,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 102554,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 102343,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 95594,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 86146,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 75565,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 67369,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 61161,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 42548,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 23737,
      "timestamp": "2023-03-11T19:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17236,
      "timestamp": "2023-03-11T19:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 405924,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 382448,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 163822,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 116172,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 104620,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 103038,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 98066,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 87394,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 75821,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 67711,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 61615,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 42601,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 23778,
      "timestamp": "2023-03-11T20:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17265,
      "timestamp": "2023-03-11T20:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 407753,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 383730,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 164666,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 116901,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 106029,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 103484,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 101023,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 88377,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 76450,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 67940,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 62126,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 43146,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 23949,
      "timestamp": "2023-03-11T21:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17282,
      "timestamp": "2023-03-11T21:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 408966,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 386262,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 165922,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 117453,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 107061,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 104957,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 103881,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 89106,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 76916,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 68112,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 62444,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 43455,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24148,
      "timestamp": "2023-03-11T22:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17313,
      "timestamp": "2023-03-11T22:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 410102,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 388541,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 166728,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 117868,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 108589,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 108205,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 104296,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 89478,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 77241,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 68218,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 63057,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 43686,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24229,
      "timestamp": "2023-03-11T23:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17343,
      "timestamp": "2023-03-11T23:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 411014,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 389599,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 167232,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 118087,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 110466,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 109237,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 104654,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 89752,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 77466,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 68342,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 63513,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 43760,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24357,
      "timestamp": "2023-03-12T00:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17360,
      "timestamp": "2023-03-12T00:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 412128,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 390216,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 167358,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 118256,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 111015,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 109550,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 104860,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 89877,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 77592,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 68396,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 63816,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 43765,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24475,
      "timestamp": "2023-03-12T01:00:00-05:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17362,
      "timestamp": "2023-03-12T01:00:00-05:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 413101,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 390578,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 167498,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 118332,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 111678,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 109776,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 104915,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 90103,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 77671,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 68415,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 63863,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 43776,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24511,
      "timestamp": "2023-03-12T03:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17375,
      "timestamp": "2023-03-12T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 413768,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 390936,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 167934,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 118406,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 112107,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 109972,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 105056,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 90234,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 77692,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 68428,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 63947,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 43785,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24515,
      "timestamp": "2023-03-12T04:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17392,
      "timestamp": "2023-03-12T04:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 414512,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 391039,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 168013,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 118485,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 112350,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 110051,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 105101,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 90306,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 77703,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 68545,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 64061,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 43803,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24520,
      "timestamp": "2023-03-12T05:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17394,
      "timestamp": "2023-03-12T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 415025,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 392115,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 168144,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 118511,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 113076,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 110161,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 105269,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 90422,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 77775,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 68631,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 64164,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 43839,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24557,
      "timestamp": "2023-03-12T06:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17396,
      "timestamp": "2023-03-12T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 415561,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 392793,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 168300,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 118717,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 113639,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 110449,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 105412,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 90641,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 78151,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 68730,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 64300,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 43853,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24574,
      "timestamp": "2023-03-12T07:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17403,
      "timestamp": "2023-03-12T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 416541,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 393995,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 168760,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 119005,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 114430,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 110610,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 105532,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 90866,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 78543,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 68854,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 64526,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 43914,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24620,
      "timestamp": "2023-03-12T08:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17419,
      "timestamp": "2023-03-12T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 418029,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 394466,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 169726,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 119177,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 115808,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 111051,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 105631,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 91322,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 78803,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 69079,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 64803,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 44183,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24648,
      "timestamp": "2023-03-12T09:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17427,
      "timestamp": "2023-03-12T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 419495,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 395479,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 170655,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 119550,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 117272,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 111535,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 105844,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 91640,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 79109,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 69669,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 64995,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 44303,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24696,
      "timestamp": "2023-03-12T10:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17442,
      "timestamp": "2023-03-12T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 421064,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 397573,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 171449,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 119896,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 119152,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 112234,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 106276,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 92084,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 79311,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 70091,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 65240,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 44571,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24720,
      "timestamp": "2023-03-12T11:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17449,
      "timestamp": "2023-03-12T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 422381,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 399021,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 172430,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 121938,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 120162,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 112848,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 106600,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 92435,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 79750,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 70416,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 65627,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 44698,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24767,
      "timestamp": "2023-03-12T12:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17468,
      "timestamp": "2023-03-12T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 424530,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 400814,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 173004,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 123880,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 120805,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 113456,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 106820,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 92861,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 80373,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 70836,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 66109,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 44851,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24813,
      "timestamp": "2023-03-12T13:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17476,
      "timestamp": "2023-03-12T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 425885,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 402565,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 174379,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 126101,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 121531,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 113902,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 107093,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 93425,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 81227,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 71218,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 66392,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 45415,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24831,
      "timestamp": "2023-03-12T14:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17484,
      "timestamp": "2023-03-12T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 427400,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 404493,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 175521,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 127486,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 122133,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 114520,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 107553,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 94057,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 82089,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 71634,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 66658,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 45595,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24930,
      "timestamp": "2023-03-12T15:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17512,
      "timestamp": "2023-03-12T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 428942,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 405800,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 176497,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 129023,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 122661,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 115202,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 107786,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 94345,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 82628,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 72021,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 66943,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 45693,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 24995,
      "timestamp": "2023-03-12T16:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17543,
      "timestamp": "2023-03-12T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 430603,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 408082,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 177341,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 130786,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 123105,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 115567,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 108013,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 95356,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 83080,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 72399,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 67377,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 45856,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25026,
      "timestamp": "2023-03-12T17:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17562,
      "timestamp": "2023-03-12T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 432155,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 410542,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 178296,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 132717,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 123632,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 116175,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 108298,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 96117,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 83418,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 72657,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 67597,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 45949,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25046,
      "timestamp": "2023-03-12T18:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17566,
      "timestamp": "2023-03-12T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 434237,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 412748,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 179649,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 134855,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 124123,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 117099,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 108508,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 96746,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 83750,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 73188,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 68109,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 46118,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25113,
      "timestamp": "2023-03-12T19:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17609,
      "timestamp": "2023-03-12T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 437271,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 414948,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 181630,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 137106,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 124896,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 118164,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 108766,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 97923,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 84333,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 73958,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 68850,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 46391,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25164,
      "timestamp": "2023-03-12T20:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17641,
      "timestamp": "2023-03-12T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 441027,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 418093,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 183612,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 139700,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 125916,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 119085,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 109078,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 99051,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 85046,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 74565,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 69598,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 46656,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25266,
      "timestamp": "2023-03-12T21:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17667,
      "timestamp": "2023-03-12T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 443936,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 420654,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 186010,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 141475,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 126624,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 120248,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 109517,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 100106,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 85444,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 74888,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 70129,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 46888,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25361,
      "timestamp": "2023-03-12T22:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17681,
      "timestamp": "2023-03-12T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 445622,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 422254,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 187582,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 144026,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 127056,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 121725,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 110060,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 100713,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 85707,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 75203,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 70725,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 47003,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25461,
      "timestamp": "2023-03-12T23:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17699,
      "timestamp": "2023-03-12T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 446966,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 423523,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 188670,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 145588,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 127443,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 122262,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 110319,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 101182,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 85814,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 75540,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 71220,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 47143,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25544,
      "timestamp": "2023-03-13T00:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T00:00:00-04:00",
      "votes": 17699
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 447721,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 424308,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 189534,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 146536,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 127636,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 122926,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 110525,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 101352,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 85973,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 75706,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 71525,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 47206,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25560,
      "timestamp": "2023-03-13T01:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17700,
      "timestamp": "2023-03-13T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 448477,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 424561,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 190083,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 147124,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 127951,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 123292,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 110638,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 101538,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 86004,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 75793,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 71629,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 47225,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25565,
      "timestamp": "2023-03-13T02:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17708,
      "timestamp": "2023-03-13T02:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 449142,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 424817,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 190518,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 147370,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 128155,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 123508,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 110642,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 101576,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 86049,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 75862,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 71643,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 47240,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25568,
      "timestamp": "2023-03-13T03:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-13T03:00:00-04:00",
      "votes": 17708
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 449542,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 425118,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 190642,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 147739,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 128197,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 123674,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 110657,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 101768,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 86084,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 75944,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 71691,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 47254,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25570,
      "timestamp": "2023-03-13T04:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17709,
      "timestamp": "2023-03-13T04:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 450169,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 426532,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 191333,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 148059,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 128221,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 123771,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 110761,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 101904,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 86089,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 76029,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 71761,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 47281,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25579,
      "timestamp": "2023-03-13T05:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17712,
      "timestamp": "2023-03-13T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 451045,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 426855,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 192407,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 148624,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 128332,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 124094,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 110810,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 102101,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 86154,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 76098,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 71900,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 47344,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25586,
      "timestamp": "2023-03-13T06:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17714,
      "timestamp": "2023-03-13T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 451953,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 427418,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 192994,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 149199,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 128671,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 124313,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 110954,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 102373,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 86545,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 76210,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 72157,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 47390,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25601,
      "timestamp": "2023-03-13T07:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17720,
      "timestamp": "2023-03-13T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 453018,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 428203,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 194493,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 150201,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 129162,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 124777,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 111101,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 102670,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 87816,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 76560,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 72367,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 47452,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25621,
      "timestamp": "2023-03-13T08:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17728,
      "timestamp": "2023-03-13T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 454341,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 430014,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 195616,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 151061,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 129756,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 125253,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 111340,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 102966,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 88755,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 76834,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 72645,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 47501,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25636,
      "timestamp": "2023-03-13T09:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17762,
      "timestamp": "2023-03-13T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 455845,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 430701,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 196489,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 151871,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 130368,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 126031,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 111521,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 103252,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 89123,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 77227,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 73126,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 47717,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25670,
      "timestamp": "2023-03-13T10:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17770,
      "timestamp": "2023-03-13T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 457787,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 433301,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 198246,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 153056,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 130737,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 126780,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 111767,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 104210,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 89536,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 77505,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 73676,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 47806,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25759,
      "timestamp": "2023-03-13T11:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17781,
      "timestamp": "2023-03-13T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 459885,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 435778,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 199512,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 153830,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 131151,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 127609,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 112216,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 105005,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 89787,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 77993,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 74188,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 47945,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25838,
      "timestamp": "2023-03-13T12:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17786,
      "timestamp": "2023-03-13T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 462160,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 437203,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 200317,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 155283,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 131561,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 128580,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 112492,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 105623,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 90170,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 78366,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 75040,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 48180,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 25937,
      "timestamp": "2023-03-13T13:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 17821,
      "timestamp": "2023-03-13T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 464639,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 439234,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 201475,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 156250,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 132038,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 129368,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 112826,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 106128,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 90414,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 78864,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 75941,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 48317,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 26062,
      "timestamp": "2023-03-13T14:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 18048,
      "timestamp": "2023-03-13T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 466426,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 440468,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 202476,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 157495,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 132445,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 130216,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 113153,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 106570,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 90858,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 79317,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 76843,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 48432,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 26107,
      "timestamp": "2023-03-13T15:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 18206,
      "timestamp": "2023-03-13T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 468396,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 442123,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 203481,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 159241,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 132928,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 131113,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 113483,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 107292,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 91222,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 79953,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 77481,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 48685,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 26211,
      "timestamp": "2023-03-13T16:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 18292,
      "timestamp": "2023-03-13T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 470175,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 443449,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 204146,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 160279,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 133920,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 131801,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 113884,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 107850,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 91558,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 80640,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 78176,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 48877,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 26308,
      "timestamp": "2023-03-13T17:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 18336,
      "timestamp": "2023-03-13T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 471748,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 444825,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 205364,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 161575,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 134453,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 132775,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 114106,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 108687,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 91825,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 81306,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 79039,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 49090,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 26365,
      "timestamp": "2023-03-13T18:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 18399,
      "timestamp": "2023-03-13T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 473425,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 446879,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 207337,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 162838,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 134971,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 134506,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 114470,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 109815,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 92314,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 81897,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 79958,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 49255,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 26502,
      "timestamp": "2023-03-13T19:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 18469,
      "timestamp": "2023-03-13T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 475655,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 450585,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 209817,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 164500,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 136399,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 136020,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 114754,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 111596,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 93076,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 82973,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 81022,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 49536,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 26590,
      "timestamp": "2023-03-13T20:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 18515,
      "timestamp": "2023-03-13T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 477576,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 451993,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 212828,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 166678,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 137856,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 136706,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 115097,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 114082,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 93978,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 84310,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 82080,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 50169,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 26735,
      "timestamp": "2023-03-13T21:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 18622,
      "timestamp": "2023-03-13T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 480757,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 453898,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 214737,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 168978,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 139464,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 137365,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 116539,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 115938,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 94980,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 85398,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 82722,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 50592,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 26848,
      "timestamp": "2023-03-13T22:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 18932,
      "timestamp": "2023-03-13T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 483259,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 456066,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 215947,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 171079,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 140569,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 137843,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 117558,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 117359,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 95395,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 85897,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 83555,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 50942,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 26958,
      "timestamp": "2023-03-13T23:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 19000,
      "timestamp": "2023-03-13T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 484415,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 458137,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 216772,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 171994,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 141079,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 137999,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 118448,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 118228,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 95705,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 86141,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 83763,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 51063,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27049,
      "timestamp": "2023-03-14T00:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 19003,
      "timestamp": "2023-03-14T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 485332,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 458797,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 217078,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 173236,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 141702,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 138284,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 119051,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 118592,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 95995,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 86180,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 83978,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 51137,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27107,
      "timestamp": "2023-03-14T01:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 19015,
      "timestamp": "2023-03-14T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 485875,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 459097,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 217322,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 173992,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 142173,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 138476,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 119266,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 118706,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 96368,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 86325,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 84162,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 51201,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27131,
      "timestamp": "2023-03-14T02:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 19018,
      "timestamp": "2023-03-14T02:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 486392,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 459203,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 217640,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 174697,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 142505,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 138638,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 119469,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 118758,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 96562,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 86584,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 84357,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 51220,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27170,
      "timestamp": "2023-03-14T03:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-14T03:00:00-04:00",
      "votes": 19018
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 486942,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 459332,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 218386,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 175223,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 142905,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 138847,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 120094,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 118909,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 96681,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 87095,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 84586,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 51224,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27180,
      "timestamp": "2023-03-14T04:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 19023,
      "timestamp": "2023-03-14T04:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 487695,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 459922,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 219271,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 175630,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 143060,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 138966,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 120447,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 119028,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 96740,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 87623,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 84684,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 51233,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27181,
      "timestamp": "2023-03-14T05:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 19028,
      "timestamp": "2023-03-14T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 488423,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 460625,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 220030,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 176026,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 143418,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 139028,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 121109,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 119100,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 96811,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 88064,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 85011,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 51325,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27191,
      "timestamp": "2023-03-14T06:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 19047,
      "timestamp": "2023-03-14T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 489817,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 461424,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 220965,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 176664,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 143628,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 139163,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 121553,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 119279,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 97114,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 88398,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 85309,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 51451,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27211,
      "timestamp": "2023-03-14T07:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 19055,
      "timestamp": "2023-03-14T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 491654,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 462713,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 222450,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 177860,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 144304,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 139569,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 122339,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 119496,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 97354,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 89106,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 85876,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 51588,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27232,
      "timestamp": "2023-03-14T08:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 19106,
      "timestamp": "2023-03-14T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 493886,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 464210,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 224290,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 179053,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 145075,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 140174,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 123388,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 119960,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 97705,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 89555,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 86410,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 51727,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27302,
      "timestamp": "2023-03-14T09:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 19244,
      "timestamp": "2023-03-14T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 496216,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 466141,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 225814,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 180489,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 146535,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 140546,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 125075,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 120378,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 98138,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 90097,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 86867,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 51826,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27372,
      "timestamp": "2023-03-14T10:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 19475,
      "timestamp": "2023-03-14T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 497917,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 468415,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 227382,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 181741,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 147492,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 141129,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 125953,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 120692,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 98398,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 91144,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 87569,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 51989,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27426,
      "timestamp": "2023-03-14T11:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 19770,
      "timestamp": "2023-03-14T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 500162,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 469463,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 229050,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 183318,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 148189,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 142117,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 127207,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 121163,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 99067,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 91821,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 88305,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 52063,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27638,
      "timestamp": "2023-03-14T12:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 19815,
      "timestamp": "2023-03-14T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 502113,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 471216,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 230214,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 184394,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 149082,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 142519,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 128510,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 121455,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 99723,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 92517,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 88985,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 52188,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27723,
      "timestamp": "2023-03-14T13:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 19900,
      "timestamp": "2023-03-14T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 504027,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 472551,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 231685,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 185667,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 149966,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 142912,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 129754,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 121884,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 100622,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 93257,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 89415,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 52366,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27778,
      "timestamp": "2023-03-14T14:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 19981,
      "timestamp": "2023-03-14T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 505509,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 474104,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 233531,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 187343,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 150563,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 143139,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 130877,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 122204,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 101255,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 93605,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 90057,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 52454,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27859,
      "timestamp": "2023-03-14T15:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20091,
      "timestamp": "2023-03-14T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 506718,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 475322,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 234559,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 188664,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 151250,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 143336,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 131424,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 122300,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 101952,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 94127,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 90345,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 52536,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 27971,
      "timestamp": "2023-03-14T16:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20121,
      "timestamp": "2023-03-14T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 507970,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 476597,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 236547,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 189202,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 151773,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 143676,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 131911,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 122526,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 102365,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 94500,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 90684,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 52619,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28032,
      "timestamp": "2023-03-14T17:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20150,
      "timestamp": "2023-03-14T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 509039,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 477517,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 237840,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 190209,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 152133,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 143926,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 132483,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 122830,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 102565,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 95056,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 90847,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 52773,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28087,
      "timestamp": "2023-03-14T18:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20172,
      "timestamp": "2023-03-14T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 510763,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 478742,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 239215,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 191164,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 152603,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 144197,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 133233,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 123058,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 102803,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 95325,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 91145,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53043,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28177,
      "timestamp": "2023-03-14T19:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20187,
      "timestamp": "2023-03-14T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 512281,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 480932,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 240580,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 192319,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 153126,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 144566,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 135374,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 123424,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 103195,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 95693,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 91380,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53140,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28319,
      "timestamp": "2023-03-14T20:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20216,
      "timestamp": "2023-03-14T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 513810,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 483754,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 241703,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 193603,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 153653,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 144751,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 136959,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 123742,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 103542,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 96017,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 91681,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53279,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28380,
      "timestamp": "2023-03-14T21:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20242,
      "timestamp": "2023-03-14T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 515022,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 485284,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 243296,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 195042,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 154347,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 145158,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 137797,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 124128,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 103796,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 96253,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 91999,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53348,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28443,
      "timestamp": "2023-03-14T22:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20262,
      "timestamp": "2023-03-14T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 516120,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 486327,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 243925,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 195971,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 154872,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 145337,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 138504,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 124473,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 104030,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 96639,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 92241,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53428,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28535,
      "timestamp": "2023-03-14T23:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20283,
      "timestamp": "2023-03-14T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 516852,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 487374,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 244715,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 197015,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 155168,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 145465,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 138719,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 124667,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 104252,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 96941,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 92397,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53440,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28669,
      "timestamp": "2023-03-15T00:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20299,
      "timestamp": "2023-03-15T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 517330,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 487497,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 244759,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 197297,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 155301,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 145491,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 138961,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 124724,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 104350,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 97105,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 92494,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53445,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28671,
      "timestamp": "2023-03-15T01:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20308,
      "timestamp": "2023-03-15T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 517786,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 487530,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 244919,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 197606,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 155448,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 145517,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 139036,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 124730,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 104431,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 97235,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 92573,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53449,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28690,
      "timestamp": "2023-03-15T02:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20313,
      "timestamp": "2023-03-15T02:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 518115,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 487583,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 244978,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 197850,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 155705,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 145560,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 139149,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 124750,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 104518,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 97253,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 92646,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53452,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28691,
      "timestamp": "2023-03-15T03:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T03:00:00-04:00",
      "votes": 20313
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 518308,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 487691,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 245047,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 198003,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 155846,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 145590,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 139239,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 124759,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 104574,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 97290,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 92665,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53465,
      "timestamp": "2023-03-15T04:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "color": "#f96302",
      "timestamp": "2023-03-15T04:00:00-04:00",
      "votes": 28691
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20331,
      "timestamp": "2023-03-15T04:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 518602,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 487764,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 245125,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 198120,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 156005,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 145676,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 139346,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 124773,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 104632,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 97345,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 92679,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53473,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28694,
      "timestamp": "2023-03-15T05:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20334,
      "timestamp": "2023-03-15T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 519123,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 487851,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 245317,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 198326,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 156148,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 145764,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 139662,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 124792,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 104727,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 97402,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 92760,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53505,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28696,
      "timestamp": "2023-03-15T06:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20337,
      "timestamp": "2023-03-15T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 519661,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 488031,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 245390,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 198659,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 156295,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 145922,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 139968,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 124865,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 104910,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 97545,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 93030,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53542,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28726,
      "timestamp": "2023-03-15T07:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20361,
      "timestamp": "2023-03-15T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 520225,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 488358,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 245671,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 199256,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 156567,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 146142,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 140387,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 125018,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 105083,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 97682,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 93167,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53615,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28762,
      "timestamp": "2023-03-15T08:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20443,
      "timestamp": "2023-03-15T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 520916,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 488666,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 245894,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 199976,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 156844,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 146432,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 140800,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 125238,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 105298,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 97993,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 93380,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53635,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28804,
      "timestamp": "2023-03-15T09:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20489,
      "timestamp": "2023-03-15T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 521460,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 489042,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 246130,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 200254,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 157164,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 146634,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 141693,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 125389,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 105678,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 98424,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 93623,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53663,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28825,
      "timestamp": "2023-03-15T10:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20507,
      "timestamp": "2023-03-15T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 522039,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 489491,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 246352,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 200494,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 157638,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 147136,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 142543,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 125608,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 105968,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 98753,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 93907,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53694,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28852,
      "timestamp": "2023-03-15T11:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20591,
      "timestamp": "2023-03-15T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 522518,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 490020,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 246688,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 200998,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 157937,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 147261,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 143127,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 125751,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 106250,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 99062,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 94100,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53796,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28877,
      "timestamp": "2023-03-15T12:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20612,
      "timestamp": "2023-03-15T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 523177,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 490850,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 247310,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 201356,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 158285,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 147481,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 143557,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 126037,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 106446,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 99290,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 94270,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53838,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28914,
      "timestamp": "2023-03-15T13:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20657,
      "timestamp": "2023-03-15T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 523701,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 491889,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 247704,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 201921,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 158757,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 147740,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 144028,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 126185,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 106690,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 99439,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 94583,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 53930,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28958,
      "timestamp": "2023-03-15T14:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20689,
      "timestamp": "2023-03-15T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 524454,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 492692,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 247993,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 202488,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 159098,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 148208,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 144556,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 126352,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 106957,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 99638,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 94762,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54009,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 28986,
      "timestamp": "2023-03-15T15:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20712,
      "timestamp": "2023-03-15T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 525429,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 493365,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 248338,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 202826,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 159431,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 148404,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 145378,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 126502,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 107252,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 100151,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 95010,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54068,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29017,
      "timestamp": "2023-03-15T16:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20749,
      "timestamp": "2023-03-15T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 526355,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 494371,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 248674,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 203242,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 159723,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 148629,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 146084,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 126700,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 107589,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 100591,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 95182,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54108,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29061,
      "timestamp": "2023-03-15T17:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20764,
      "timestamp": "2023-03-15T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 527207,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 495021,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 248858,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 203717,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 160042,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 148808,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 146778,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 126885,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 107844,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 101076,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 95407,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54144,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29106,
      "timestamp": "2023-03-15T18:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20795,
      "timestamp": "2023-03-15T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 528065,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 495563,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 249246,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 204477,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 160487,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 149282,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 147742,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 127122,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 108183,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 101313,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 95735,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54207,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29138,
      "timestamp": "2023-03-15T19:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20808,
      "timestamp": "2023-03-15T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 528610,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 496050,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 249655,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 205046,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 160846,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 149661,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 149390,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 127407,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 108474,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 101592,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 96052,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54246,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29201,
      "timestamp": "2023-03-15T20:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20835,
      "timestamp": "2023-03-15T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 529467,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 497091,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 250116,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 205903,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 161390,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 152096,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 150347,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 127570,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 108808,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 101863,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 96378,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54289,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29264,
      "timestamp": "2023-03-15T21:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 20887,
      "timestamp": "2023-03-15T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 531089,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 497736,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 250518,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 206685,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 161827,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 153991,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 150771,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 127912,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 109120,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 102113,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 96718,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54333,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29298,
      "timestamp": "2023-03-15T22:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21031,
      "timestamp": "2023-03-15T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 531849,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 498218,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 250830,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 207490,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 162310,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 154651,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 150997,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 128138,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 109280,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 102321,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 96996,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54374,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29342,
      "timestamp": "2023-03-15T23:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21035,
      "timestamp": "2023-03-15T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 532482,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 499013,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 251207,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 208032,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 162687,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 155112,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 151188,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 128359,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 109494,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 102396,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 97081,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54446,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29377,
      "timestamp": "2023-03-16T00:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21040,
      "timestamp": "2023-03-16T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 533010,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 499649,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 251679,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 208466,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 163034,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 155317,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 151243,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 128457,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 109609,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 102477,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 97115,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54543,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29381,
      "timestamp": "2023-03-16T01:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21041,
      "timestamp": "2023-03-16T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 533256,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 499901,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 251805,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 208869,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 163207,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 155419,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 151319,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 128515,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 109757,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 102632,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 97159,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54562,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29398,
      "timestamp": "2023-03-16T02:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T02:00:00-04:00",
      "votes": 21041
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 533498,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 500284,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 252013,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 209194,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 163312,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 155479,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 151393,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 128530,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 109826,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 102687,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 97189,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54567,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29410,
      "timestamp": "2023-03-16T03:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21044,
      "timestamp": "2023-03-16T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 533768,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 500614,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 252764,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 209284,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 163372,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 155584,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 151455,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 128544,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 109931,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 102708,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 97203,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54578,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29412,
      "timestamp": "2023-03-16T04:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-16T04:00:00-04:00",
      "votes": 21044
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 534289,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 501490,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 253244,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 209347,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 163553,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 155791,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 151494,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 128558,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 110060,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 102764,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 97246,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54581,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29421,
      "timestamp": "2023-03-16T05:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21046,
      "timestamp": "2023-03-16T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 534744,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 502445,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 254324,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 209520,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 163672,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 156028,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 151666,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 128590,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 110135,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 102907,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 97330,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54600,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29426,
      "timestamp": "2023-03-16T06:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21051,
      "timestamp": "2023-03-16T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 535184,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 502723,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 254535,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 210034,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 163724,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 156380,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 151764,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 128709,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 110210,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 103101,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 97400,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54636,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29446,
      "timestamp": "2023-03-16T07:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21064,
      "timestamp": "2023-03-16T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 535616,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 504072,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 255180,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 210568,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 163969,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 156914,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 151941,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 128826,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 110405,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 103294,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 97604,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54675,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29504,
      "timestamp": "2023-03-16T08:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21127,
      "timestamp": "2023-03-16T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 536377,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 505231,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 255945,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 211869,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 164502,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 157411,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 152229,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 128951,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 110675,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 103659,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 97775,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54711,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29534,
      "timestamp": "2023-03-16T09:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21148,
      "timestamp": "2023-03-16T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 537062,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 506510,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 256969,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 212889,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 165092,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 158210,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 152560,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 129167,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 111001,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 104031,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 98040,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54800,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29549,
      "timestamp": "2023-03-16T10:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21165,
      "timestamp": "2023-03-16T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 537681,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 507875,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 257882,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 213358,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 165521,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 158878,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 152683,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 129350,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 111196,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 104127,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 98279,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54886,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29561,
      "timestamp": "2023-03-16T11:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21239,
      "timestamp": "2023-03-16T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 538250,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 509486,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 258780,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 214247,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 166072,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 160097,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 152903,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 129551,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 111299,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 104201,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 98475,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 54937,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29597,
      "timestamp": "2023-03-16T12:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21258,
      "timestamp": "2023-03-16T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 539047,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 510882,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 259515,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 215328,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 166601,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 161572,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 153052,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 129714,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 111470,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 104351,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 98604,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55043,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29630,
      "timestamp": "2023-03-16T13:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21293,
      "timestamp": "2023-03-16T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 540317,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 511438,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 260171,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 216377,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 167302,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 162721,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 153128,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 129818,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 111613,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 104774,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 98838,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55086,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29712,
      "timestamp": "2023-03-16T14:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21308,
      "timestamp": "2023-03-16T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 541153,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 512729,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 260850,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 217125,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 167831,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 163779,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 153327,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 130006,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 111745,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 105140,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 99138,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55166,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29756,
      "timestamp": "2023-03-16T15:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21315,
      "timestamp": "2023-03-16T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 541937,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 514474,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 261824,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 217842,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 168261,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 164760,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 153506,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 130203,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 111994,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 105312,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 99467,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55203,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29805,
      "timestamp": "2023-03-16T16:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21342,
      "timestamp": "2023-03-16T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 542918,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 515761,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 262484,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 218843,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 168835,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 166036,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 153705,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 130432,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 112124,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 105432,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 100273,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55265,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29832,
      "timestamp": "2023-03-16T17:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21353,
      "timestamp": "2023-03-16T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 543784,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 516617,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 263376,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 220092,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 169355,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 167459,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 153951,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 130532,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 112424,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 105742,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 100662,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55339,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29868,
      "timestamp": "2023-03-16T18:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21362,
      "timestamp": "2023-03-16T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 544903,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 518208,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 264906,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 221217,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 170126,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 169269,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 154218,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 130713,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 112733,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 106205,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 101017,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55422,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 29931,
      "timestamp": "2023-03-16T19:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21377,
      "timestamp": "2023-03-16T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 546237,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 520070,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 265817,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 222282,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 173338,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 171170,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 154460,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 130820,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 113167,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 106662,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 101626,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55449,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30003,
      "timestamp": "2023-03-16T20:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21424,
      "timestamp": "2023-03-16T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 548949,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 521656,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 267338,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 224579,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 175921,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 172069,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 154912,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 131088,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 113690,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 107043,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 102228,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55574,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30065,
      "timestamp": "2023-03-16T21:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21433,
      "timestamp": "2023-03-16T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 550589,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 522551,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 269181,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 225818,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 177912,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 172687,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 155261,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 131416,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 114112,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 107397,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 102661,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55684,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30116,
      "timestamp": "2023-03-16T22:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21447,
      "timestamp": "2023-03-16T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 551857,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 524676,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 271075,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 227316,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 179401,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 172992,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 155505,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 131591,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 114253,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 107606,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 103192,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55732,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30131,
      "timestamp": "2023-03-16T23:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21453,
      "timestamp": "2023-03-16T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 553068,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 525223,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 271908,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 228562,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 180229,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 173245,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 155684,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 131756,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 114334,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 107776,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 103617,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55771,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30148,
      "timestamp": "2023-03-17T00:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21456,
      "timestamp": "2023-03-17T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 554411,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 526030,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 272476,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 229977,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 180529,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 173482,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 155794,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 131873,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 114383,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 108163,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 103778,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55787,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30161,
      "timestamp": "2023-03-17T01:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T01:00:00-04:00",
      "votes": 21456
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 555840,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 526517,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 272603,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 230559,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 180741,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 173652,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 155867,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 131962,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 114449,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 108536,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 103947,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55855,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30168,
      "timestamp": "2023-03-17T02:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21458,
      "timestamp": "2023-03-17T02:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 556861,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 526631,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 272795,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 230942,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 180830,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 173807,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 155976,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 132010,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 114463,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 108832,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 104082,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55878,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30173,
      "timestamp": "2023-03-17T03:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21459,
      "timestamp": "2023-03-17T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 557666,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 526901,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 273459,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 231061,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 180990,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 173945,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 156061,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 132044,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 114528,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 109209,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 104139,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55892,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30185,
      "timestamp": "2023-03-17T04:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-17T04:00:00-04:00",
      "votes": 21459
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 558650,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 527893,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 274032,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 231110,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 181283,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 174005,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 156082,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 132061,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 114614,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 109251,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 104178,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55900,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30190,
      "timestamp": "2023-03-17T05:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21461,
      "timestamp": "2023-03-17T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 559850,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 528442,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 274908,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 231340,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 181765,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 174178,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 156185,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 132094,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 114716,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 109324,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 104235,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55926,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30200,
      "timestamp": "2023-03-17T06:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21470,
      "timestamp": "2023-03-17T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 560740,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 528699,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 275269,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 232109,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 182245,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 174391,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 156501,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 132135,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 114836,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 109388,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 104305,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55957,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30246,
      "timestamp": "2023-03-17T07:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21474,
      "timestamp": "2023-03-17T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 561603,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 529504,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 276217,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 232748,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 182925,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 174570,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 156707,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 132188,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 115099,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 109507,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 104509,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 55985,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30313,
      "timestamp": "2023-03-17T08:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21476,
      "timestamp": "2023-03-17T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 562581,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 530784,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 277090,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 233221,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 183614,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 174856,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 156946,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 132294,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 115213,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 109754,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 104901,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56036,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30350,
      "timestamp": "2023-03-17T09:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21489,
      "timestamp": "2023-03-17T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 563556,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 532599,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 277655,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 233822,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 184326,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 175118,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 157292,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 132435,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 115392,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 110085,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 105235,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56098,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30396,
      "timestamp": "2023-03-17T10:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21504,
      "timestamp": "2023-03-17T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 564676,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 534010,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 278639,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 234721,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 185427,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 175427,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 157454,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 132587,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 115672,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 110415,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 105511,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56127,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30430,
      "timestamp": "2023-03-17T11:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21544,
      "timestamp": "2023-03-17T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 565438,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 535116,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 279575,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 235698,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 186858,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 175832,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 157751,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 132768,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 115819,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 110697,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 105894,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56162,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30458,
      "timestamp": "2023-03-17T12:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21615,
      "timestamp": "2023-03-17T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 566894,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 537156,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 280161,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 236623,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 187980,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 176310,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 158109,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 132962,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 116030,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 110969,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 106102,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56190,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30509,
      "timestamp": "2023-03-17T13:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21634,
      "timestamp": "2023-03-17T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 567707,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 537680,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 280852,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 237625,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 189049,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 176639,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 158317,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 133217,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 116170,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 111229,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 106284,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56216,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30566,
      "timestamp": "2023-03-17T14:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21645,
      "timestamp": "2023-03-17T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 569072,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 538661,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 282079,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 238599,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 190082,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 177005,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 158424,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 133325,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 116409,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 111561,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 106541,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56249,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30606,
      "timestamp": "2023-03-17T15:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21649,
      "timestamp": "2023-03-17T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 570143,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 539625,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 282831,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 239591,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 191226,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 177317,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 158570,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 133437,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 116832,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 111832,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 106766,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56275,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30627,
      "timestamp": "2023-03-17T16:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21653,
      "timestamp": "2023-03-17T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 570888,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 540682,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 284232,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 241318,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 191954,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 177607,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 158813,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 133565,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 117206,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 112034,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 107072,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56298,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30646,
      "timestamp": "2023-03-17T17:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21663,
      "timestamp": "2023-03-17T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 572231,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 541809,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 285325,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 242646,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 192665,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 178057,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 159051,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 133695,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 117626,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 112321,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 107329,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56322,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30675,
      "timestamp": "2023-03-17T18:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21665,
      "timestamp": "2023-03-17T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 574021,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 542547,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 286425,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 244312,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 193596,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 178581,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 159283,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 133850,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 118046,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 112574,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 107480,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56378,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30725,
      "timestamp": "2023-03-17T19:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21675,
      "timestamp": "2023-03-17T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 575580,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 545071,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 288499,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 245619,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 194741,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 179165,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 159514,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 134215,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 118448,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 112824,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 107633,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56406,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30783,
      "timestamp": "2023-03-17T20:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21693,
      "timestamp": "2023-03-17T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 577012,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 546298,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 289769,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 247170,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 195764,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 179526,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 159741,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 134323,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 118908,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 113188,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 107815,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56440,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30817,
      "timestamp": "2023-03-17T21:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21727,
      "timestamp": "2023-03-17T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 578595,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 547713,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 290842,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 248298,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 196776,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 180056,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 159999,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 134539,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 119361,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 113399,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 108054,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56471,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30855,
      "timestamp": "2023-03-17T22:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21754,
      "timestamp": "2023-03-17T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 580575,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 550688,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 291882,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 249624,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 197560,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 180588,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 160265,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 134759,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 119453,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 113750,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 108342,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56511,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30878,
      "timestamp": "2023-03-17T23:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21788,
      "timestamp": "2023-03-17T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 583384,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 551571,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 292346,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 251457,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 197969,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 181109,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 160497,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 134951,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 119570,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 113879,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 108629,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56526,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30899,
      "timestamp": "2023-03-18T00:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21798,
      "timestamp": "2023-03-18T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 585447,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 551956,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 293056,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 251834,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 198152,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 181381,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 160670,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 135085,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 119582,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 114017,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 108835,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56533,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30905,
      "timestamp": "2023-03-18T01:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T01:00:00-04:00",
      "votes": 21798
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 586740,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 552175,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 293422,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 252040,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 198264,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 181562,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 160714,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 135110,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 119677,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 114102,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 109072,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56567,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30910,
      "timestamp": "2023-03-18T02:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21800,
      "timestamp": "2023-03-18T02:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 587429,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 552437,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 293719,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 252311,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 198342,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 181667,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 160752,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 135125,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 119836,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 114131,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 109214,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56570,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30914,
      "timestamp": "2023-03-18T03:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21801,
      "timestamp": "2023-03-18T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 587843,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 552730,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 294098,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 252371,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 198473,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 181795,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 160779,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 135141,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 120022,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 114150,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 109236,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56580,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30916,
      "timestamp": "2023-03-18T04:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-18T04:00:00-04:00",
      "votes": 21801
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 588157,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 552952,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 294523,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 252615,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 198596,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 181829,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 160795,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 135167,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 120131,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 114204,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 109280,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56589,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30917,
      "timestamp": "2023-03-18T05:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21803,
      "timestamp": "2023-03-18T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 589205,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 553543,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 294777,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 252774,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 198836,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 181859,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 160873,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 135210,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 120222,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 114252,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 109377,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56617,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30923,
      "timestamp": "2023-03-18T06:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21804,
      "timestamp": "2023-03-18T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 590009,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 554293,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 295229,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 253268,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 199364,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 181969,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 161003,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 135233,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 120372,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 114365,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 109453,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56627,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30931,
      "timestamp": "2023-03-18T07:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21807,
      "timestamp": "2023-03-18T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 591307,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 555076,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 296436,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 254065,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 200299,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 182168,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 161095,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 135264,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 120597,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 114559,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 109589,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56642,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 30974,
      "timestamp": "2023-03-18T08:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21814,
      "timestamp": "2023-03-18T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 593578,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 555799,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 297458,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 254516,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 200906,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 182463,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 161251,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 135323,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 120972,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 114824,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 109770,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56662,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31032,
      "timestamp": "2023-03-18T09:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21819,
      "timestamp": "2023-03-18T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 595504,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 557291,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 298064,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 255528,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 201572,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 182771,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 161380,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 135489,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 121146,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 115083,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 109973,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56706,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31064,
      "timestamp": "2023-03-18T10:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21824,
      "timestamp": "2023-03-18T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 597331,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 558769,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 298911,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 256488,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 202194,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 183059,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 161626,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 135645,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 121479,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 115309,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 110216,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56778,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31103,
      "timestamp": "2023-03-18T11:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21835,
      "timestamp": "2023-03-18T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 598929,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 559656,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 300256,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 257058,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 202618,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 183350,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 161782,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 135910,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 121682,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 115623,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 110520,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56840,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31132,
      "timestamp": "2023-03-18T12:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21844,
      "timestamp": "2023-03-18T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 601442,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 560333,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 301107,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 258131,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 203053,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 183614,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 161965,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 136034,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 121993,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 115811,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 110764,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56892,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31148,
      "timestamp": "2023-03-18T13:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21851,
      "timestamp": "2023-03-18T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 603216,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 560909,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 301670,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 259216,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 203568,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 183826,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 162248,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 136151,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 122204,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 115963,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 111022,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56919,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31180,
      "timestamp": "2023-03-18T14:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21868,
      "timestamp": "2023-03-18T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 604695,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 562164,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 302886,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 260330,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 204227,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 184129,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 162423,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 136277,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 122565,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 116128,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 111220,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 56945,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31208,
      "timestamp": "2023-03-18T15:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21882,
      "timestamp": "2023-03-18T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 606529,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 563059,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 303623,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 261140,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 204739,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 184489,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 162636,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 136512,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 122926,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 116297,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 111480,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57022,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31264,
      "timestamp": "2023-03-18T16:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21885,
      "timestamp": "2023-03-18T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 608181,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 564348,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 304519,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 262223,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 205137,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 184774,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 162811,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 136713,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 123113,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 116567,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 111697,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57076,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31318,
      "timestamp": "2023-03-18T17:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21896,
      "timestamp": "2023-03-18T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 609983,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 565555,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 305300,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 263373,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 205694,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 185206,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 163014,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 136969,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 123326,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 116886,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 111847,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57091,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31337,
      "timestamp": "2023-03-18T18:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21903,
      "timestamp": "2023-03-18T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 612424,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 566875,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 305913,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 264454,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 206206,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 185721,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 163290,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 137159,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 123528,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 117230,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 112044,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57142,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31360,
      "timestamp": "2023-03-18T19:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21906,
      "timestamp": "2023-03-18T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 614939,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 567763,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 307474,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 265839,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 206880,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 186066,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 163545,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 137355,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 123836,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 117463,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 112255,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57185,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31381,
      "timestamp": "2023-03-18T20:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21910,
      "timestamp": "2023-03-18T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 616200,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 569229,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 308773,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 267788,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 207369,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 186335,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 163907,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 137591,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 124101,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 117800,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 112435,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57236,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31413,
      "timestamp": "2023-03-18T21:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21913,
      "timestamp": "2023-03-18T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 618436,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 570507,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 310004,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 269686,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 207796,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 186679,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 164154,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 137778,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 124276,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 118093,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 112618,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57293,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31441,
      "timestamp": "2023-03-18T22:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21916,
      "timestamp": "2023-03-18T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 620454,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 571588,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 311711,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 271945,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 208129,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 187074,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 164293,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 138021,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 124458,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 118284,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 112883,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57324,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31465,
      "timestamp": "2023-03-18T23:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21920,
      "timestamp": "2023-03-18T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 623432,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 572878,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 313092,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 272711,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 208405,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 187304,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 164404,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 138310,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 124578,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 118465,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 113104,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57370,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31479,
      "timestamp": "2023-03-19T00:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T00:00:00-04:00",
      "votes": 21920
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 624643,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 573734,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 313782,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 273507,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 208609,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 187511,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 164549,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 138421,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 124643,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 118529,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 113228,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57501,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31530,
      "timestamp": "2023-03-19T01:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21927,
      "timestamp": "2023-03-19T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 625187,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 574261,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 314043,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 273932,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 208803,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 187576,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 164610,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 138491,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 124726,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 118559,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 113318,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57507,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31533,
      "timestamp": "2023-03-19T02:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21945,
      "timestamp": "2023-03-19T02:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 625531,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 574492,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 314780,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 274400,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 208850,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 187656,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 164617,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 138522,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 124744,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 118594,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 113330,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57513,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31536,
      "timestamp": "2023-03-19T03:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T03:00:00-04:00",
      "votes": 21945
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 625929,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 574730,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 314810,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 274558,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 209043,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 187687,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 164622,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 138550,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 124817,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 118621,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 113383,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57518,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31537,
      "timestamp": "2023-03-19T04:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21952,
      "timestamp": "2023-03-19T04:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 626215,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 574848,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 314978,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 274605,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 209137,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 187721,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 164642,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 138556,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 124854,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 118638,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 113456,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57521,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31539,
      "timestamp": "2023-03-19T05:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21953,
      "timestamp": "2023-03-19T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 626645,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 575378,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 315237,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 274699,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 209331,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 187746,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 164761,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 138563,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 125037,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 118682,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 113546,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57551,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31540,
      "timestamp": "2023-03-19T06:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-19T06:00:00-04:00",
      "votes": 21953
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 627031,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 575897,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 315950,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 275071,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 209589,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 187929,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 164806,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 138608,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 125155,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 118797,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 113613,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57572,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31567,
      "timestamp": "2023-03-19T07:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21957,
      "timestamp": "2023-03-19T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 628261,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 576494,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 317018,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 275931,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 210034,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 188037,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 164839,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 138693,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 125303,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 118955,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 113705,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57616,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31596,
      "timestamp": "2023-03-19T08:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21961,
      "timestamp": "2023-03-19T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 629305,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 577264,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 317681,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 277024,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 210274,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 188149,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 164937,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 138765,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 125411,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 119408,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 113831,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57644,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31703,
      "timestamp": "2023-03-19T09:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21968,
      "timestamp": "2023-03-19T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 631534,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 578343,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 318281,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 277925,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 210682,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 188491,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 165085,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 138813,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 125512,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 119658,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 113923,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57660,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31709,
      "timestamp": "2023-03-19T10:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21978,
      "timestamp": "2023-03-19T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 632564,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 579501,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 319253,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 279130,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 211112,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 188717,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 165205,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 138879,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 125668,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 119859,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 114149,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57679,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31738,
      "timestamp": "2023-03-19T11:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21981,
      "timestamp": "2023-03-19T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 633609,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 580134,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 320619,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 280176,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 211428,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 189030,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 165342,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 138983,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 125865,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 119953,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 114338,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57686,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31756,
      "timestamp": "2023-03-19T12:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21983,
      "timestamp": "2023-03-19T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 634638,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 581410,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 321394,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 281329,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 211779,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 189192,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 165459,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 139134,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 126254,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 120147,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 114504,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57733,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31781,
      "timestamp": "2023-03-19T13:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21988,
      "timestamp": "2023-03-19T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 635555,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 582360,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 322373,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 282300,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 212175,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 189400,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 165641,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 139238,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 126563,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 120320,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 114652,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57766,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31810,
      "timestamp": "2023-03-19T14:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 21989,
      "timestamp": "2023-03-19T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 638368,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 583538,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 323525,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 283127,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 212592,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 189783,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 165766,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 139368,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 126794,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 120615,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 114846,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57786,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31826,
      "timestamp": "2023-03-19T15:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22051,
      "timestamp": "2023-03-19T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 640157,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 584732,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 324226,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 284072,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 213048,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 190142,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 166004,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 139653,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 126993,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 120791,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 114985,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57865,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31847,
      "timestamp": "2023-03-19T16:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22092,
      "timestamp": "2023-03-19T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 641839,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 585639,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 325126,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 285147,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 213564,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 190462,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 166112,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 139793,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 127215,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 121047,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 115179,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57888,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31874,
      "timestamp": "2023-03-19T17:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22096,
      "timestamp": "2023-03-19T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 643598,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 586738,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 326405,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 286336,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 214084,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 190765,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 166281,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 139960,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 127589,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 121198,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 115400,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57956,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31914,
      "timestamp": "2023-03-19T18:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22102,
      "timestamp": "2023-03-19T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 645879,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 589266,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 327226,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 287395,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 214549,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 191076,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 166440,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 140101,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 127876,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 121416,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 115643,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 57969,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 31943,
      "timestamp": "2023-03-19T19:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22111,
      "timestamp": "2023-03-19T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 648914,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 590613,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 328338,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 289446,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 215182,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 191252,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 166604,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 140200,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 128232,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 121798,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 115935,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58004,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32055,
      "timestamp": "2023-03-19T20:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22122,
      "timestamp": "2023-03-19T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 652049,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 592353,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 330596,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 290954,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 215629,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 191580,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 166873,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 140444,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 128441,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 122011,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 116229,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58068,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32113,
      "timestamp": "2023-03-19T21:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22133,
      "timestamp": "2023-03-19T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 654260,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 593784,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 331877,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 291975,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 215991,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 192047,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 167084,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 140709,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 128607,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 122164,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 116384,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58098,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32218,
      "timestamp": "2023-03-19T22:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22174,
      "timestamp": "2023-03-19T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 657266,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 595602,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 333670,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 293278,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 216309,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 192472,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 167196,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 140882,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 128828,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 122382,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 116431,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58126,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32270,
      "timestamp": "2023-03-19T23:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22177,
      "timestamp": "2023-03-19T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 659814,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 596960,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 335110,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 294656,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 216436,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 192859,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 167316,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 141017,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 128900,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 122454,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 116548,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58146,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32279,
      "timestamp": "2023-03-20T00:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22191,
      "timestamp": "2023-03-20T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 660705,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 597810,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 335364,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 295940,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 216689,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 193214,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 167409,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 141058,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 128957,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 122485,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 116615,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58154,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32333,
      "timestamp": "2023-03-20T01:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T01:00:00-04:00",
      "votes": 22191
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 661030,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 598489,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 335478,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 296033,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 216828,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 193308,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 167439,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 141249,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 128983,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 122488,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 116664,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58157,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32338,
      "timestamp": "2023-03-20T02:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T02:00:00-04:00",
      "votes": 22191
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 661439,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 598966,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 335553,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 296240,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 216863,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 193406,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 167448,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 141283,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 129043,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 122503,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 116683,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58163,
      "timestamp": "2023-03-20T03:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T03:00:00-04:00",
      "votes": 32338
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T03:00:00-04:00",
      "votes": 22191
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 662033,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 599303,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 335725,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 296556,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 216982,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 193441,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 167473,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 141332,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 129049,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 122508,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 116720,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58168,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32374,
      "timestamp": "2023-03-20T04:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-20T04:00:00-04:00",
      "votes": 22191
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 662396,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 599567,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 336060,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 296832,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 217049,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 193455,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 167515,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 141361,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 129075,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 122535,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 116798,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58180,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32411,
      "timestamp": "2023-03-20T05:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22192,
      "timestamp": "2023-03-20T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 663346,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 600059,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 336652,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 297237,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 217137,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 193538,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 167563,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 141377,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 129162,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 122678,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 116843,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58192,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32415,
      "timestamp": "2023-03-20T06:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22193,
      "timestamp": "2023-03-20T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 664087,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 600880,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 337012,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 298212,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 217318,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 193621,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 167675,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 141393,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 129261,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 122734,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 116913,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58219,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32423,
      "timestamp": "2023-03-20T07:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22198,
      "timestamp": "2023-03-20T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 665819,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 602208,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 338116,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 299215,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 217607,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 193733,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 167796,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 141458,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 129423,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 122801,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 117046,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58236,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32433,
      "timestamp": "2023-03-20T08:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22199,
      "timestamp": "2023-03-20T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 667652,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 603462,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 338957,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 300513,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 218027,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 193908,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 167934,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 141650,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 129675,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 123045,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 117258,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58261,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32457,
      "timestamp": "2023-03-20T09:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22206,
      "timestamp": "2023-03-20T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 669081,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 604643,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 340875,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 301554,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 218516,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 194265,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 168046,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 141833,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 130015,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 123149,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 117406,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58278,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32482,
      "timestamp": "2023-03-20T10:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22207,
      "timestamp": "2023-03-20T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 670504,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 606252,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 342495,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 302454,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 218928,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 194491,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 168208,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 141986,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 130260,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 123282,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 117672,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58332,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32503,
      "timestamp": "2023-03-20T11:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22213,
      "timestamp": "2023-03-20T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 671444,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 607188,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 343676,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 303087,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 219328,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 194803,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 168486,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 142154,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 130466,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 123368,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 117879,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58390,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32517,
      "timestamp": "2023-03-20T12:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22221,
      "timestamp": "2023-03-20T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 672595,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 608400,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 345226,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 304021,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 220406,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 195104,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 168639,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 142310,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 130703,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 123533,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 118014,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58416,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32576,
      "timestamp": "2023-03-20T13:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22230,
      "timestamp": "2023-03-20T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 673987,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 610430,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 347128,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 304796,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 221277,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 195344,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 168824,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 142430,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 130921,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 123685,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 118169,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58438,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32640,
      "timestamp": "2023-03-20T14:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22257,
      "timestamp": "2023-03-20T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 674897,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 611274,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 348406,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 305756,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 221858,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 195905,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 168970,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 142650,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 131142,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 123828,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 118361,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58477,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32721,
      "timestamp": "2023-03-20T15:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22292,
      "timestamp": "2023-03-20T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 676052,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 613172,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 349102,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 306537,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 222493,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 196321,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 169121,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 142905,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 131456,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 123919,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 118493,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58549,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32738,
      "timestamp": "2023-03-20T16:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22306,
      "timestamp": "2023-03-20T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 677553,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 614208,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 350325,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 307848,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 223118,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 197257,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 169318,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 143048,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 131748,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 124089,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 118746,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58580,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32808,
      "timestamp": "2023-03-20T17:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22307,
      "timestamp": "2023-03-20T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 679947,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 615082,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 352736,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 309372,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 223962,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 198323,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 169478,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 143420,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 131893,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 124241,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 119076,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58624,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32917,
      "timestamp": "2023-03-20T18:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22312,
      "timestamp": "2023-03-20T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 681414,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 615538,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 353627,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 310480,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 224717,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 198773,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 169755,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 143616,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 132101,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 124531,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 119304,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58656,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32928,
      "timestamp": "2023-03-20T19:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22314,
      "timestamp": "2023-03-20T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 683457,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 617771,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 355122,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 311342,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 225587,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 199266,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 169988,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 143938,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 132351,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 124980,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 119705,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58682,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 32987,
      "timestamp": "2023-03-20T20:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22326,
      "timestamp": "2023-03-20T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 685774,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 619579,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 356452,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 313151,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 226429,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 199959,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 170455,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 144281,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 132567,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 125175,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 120092,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58726,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33091,
      "timestamp": "2023-03-20T21:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22343,
      "timestamp": "2023-03-20T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 687760,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 620722,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 357968,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 314607,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 227247,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 200653,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 170708,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 144509,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 132759,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 125393,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 120360,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58783,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33116,
      "timestamp": "2023-03-20T22:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22411,
      "timestamp": "2023-03-20T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 690824,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 623165,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 358947,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 315519,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 227671,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 201391,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 170988,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 144815,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 132884,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 125735,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 120572,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58822,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33139,
      "timestamp": "2023-03-20T23:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22472,
      "timestamp": "2023-03-20T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 692330,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 624831,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 359526,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 316573,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 227933,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 201796,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 171174,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 144940,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 133130,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 125930,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 120673,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58841,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33146,
      "timestamp": "2023-03-21T00:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22475,
      "timestamp": "2023-03-21T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 693413,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 625231,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 359554,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 318112,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 228090,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 202119,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 171318,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 145005,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 133274,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 126059,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 120704,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58843,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33164,
      "timestamp": "2023-03-21T01:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22476,
      "timestamp": "2023-03-21T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 693631,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 625347,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 359585,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 318886,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 228135,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 202222,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 171471,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 145070,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 133325,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 126115,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 120816,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58847,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33171,
      "timestamp": "2023-03-21T02:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T02:00:00-04:00",
      "votes": 22476
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 694233,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 626068,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 359873,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 319262,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 228176,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 202346,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 171562,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 145132,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 133336,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 126136,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 120938,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58857,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33172,
      "timestamp": "2023-03-21T03:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22478,
      "timestamp": "2023-03-21T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 694520,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 626797,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 360299,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 319370,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 228263,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 202397,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 171631,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 145174,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 133398,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 126156,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 120952,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58860,
      "timestamp": "2023-03-21T04:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T04:00:00-04:00",
      "votes": 33172
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22479,
      "timestamp": "2023-03-21T04:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 695605,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 627017,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 360635,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 319471,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 228367,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 202445,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 171686,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 145179,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 133446,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 126161,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 120972,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58862,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33188,
      "timestamp": "2023-03-21T05:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-21T05:00:00-04:00",
      "votes": 22479
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 696745,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 627991,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 361993,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 319661,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 228663,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 202529,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 171745,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 145190,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 133533,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 126201,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 120995,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58866,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33193,
      "timestamp": "2023-03-21T06:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22483,
      "timestamp": "2023-03-21T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 697639,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 628539,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 362333,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 320347,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 229034,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 202671,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 171806,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 145209,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 133821,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 126252,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 121020,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58881,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33211,
      "timestamp": "2023-03-21T07:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22484,
      "timestamp": "2023-03-21T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 700560,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 630465,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 363266,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 320901,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 229356,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 202890,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 171868,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 145367,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 134020,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 126334,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 121117,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58931,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33233,
      "timestamp": "2023-03-21T08:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22487,
      "timestamp": "2023-03-21T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 701992,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 631622,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 363996,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 322026,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 229758,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 203209,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 172064,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 145505,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 134199,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 126448,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 121374,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58957,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33248,
      "timestamp": "2023-03-21T09:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22488,
      "timestamp": "2023-03-21T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 703770,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 632504,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 364799,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 323035,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 230122,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 203663,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 172195,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 145605,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 134372,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 126623,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 121562,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58968,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33261,
      "timestamp": "2023-03-21T10:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22498,
      "timestamp": "2023-03-21T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 705052,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 633657,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 365559,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 323395,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 230457,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 204294,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 172294,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 145744,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 134534,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 126707,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 121681,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 58991,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33279,
      "timestamp": "2023-03-21T11:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22526,
      "timestamp": "2023-03-21T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 705688,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 635253,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 366504,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 323945,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 230811,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 204669,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 172463,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 145938,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 134692,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 126789,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 121855,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59020,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33294,
      "timestamp": "2023-03-21T12:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22540,
      "timestamp": "2023-03-21T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 706830,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 636490,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 367060,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 324357,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 231306,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 204958,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 172607,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 146062,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 134850,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 127116,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 122066,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59050,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33325,
      "timestamp": "2023-03-21T13:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22555,
      "timestamp": "2023-03-21T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 707572,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 637350,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 368312,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 325092,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 231670,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 205217,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 172717,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 146208,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 135017,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 127280,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 122238,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59070,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33339,
      "timestamp": "2023-03-21T14:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22566,
      "timestamp": "2023-03-21T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 708643,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 639259,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 369362,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 325939,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 232088,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 205671,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 172821,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 146332,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 135119,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 127410,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 122305,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59105,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33412,
      "timestamp": "2023-03-21T15:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22571,
      "timestamp": "2023-03-21T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 709615,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 640609,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 370240,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 327207,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 232338,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 206151,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 173025,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 146406,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 135284,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 127511,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 122463,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59119,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33456,
      "timestamp": "2023-03-21T16:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22574,
      "timestamp": "2023-03-21T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 710646,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 641545,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 372003,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 327786,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 232654,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 206349,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 173236,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 146541,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 135493,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 127768,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 122578,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59151,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33462,
      "timestamp": "2023-03-21T17:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22577,
      "timestamp": "2023-03-21T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 712227,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 642872,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 373154,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 328449,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 232996,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 206794,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 173471,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 146655,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 135761,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 127949,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 122705,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59199,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33472,
      "timestamp": "2023-03-21T18:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22584,
      "timestamp": "2023-03-21T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 713268,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 643895,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 374259,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 330061,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 233526,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 207172,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 173581,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 146776,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 136203,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 128308,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 122847,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59244,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33486,
      "timestamp": "2023-03-21T19:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22587,
      "timestamp": "2023-03-21T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 714772,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 645135,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 375281,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 331943,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 234576,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 207447,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 173676,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 147011,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 136384,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 128648,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 123016,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59275,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33530,
      "timestamp": "2023-03-21T20:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22592,
      "timestamp": "2023-03-21T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 716527,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 645989,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 377178,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 333512,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 235355,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 207908,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 174028,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 147458,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 136688,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 129056,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 123153,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59299,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33636,
      "timestamp": "2023-03-21T21:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22605,
      "timestamp": "2023-03-21T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 718201,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 647347,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 378499,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 335704,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 236116,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 208351,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 174230,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 147599,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 136975,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 129290,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 123441,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59314,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33657,
      "timestamp": "2023-03-21T22:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22609,
      "timestamp": "2023-03-21T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 721114,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 649150,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 379356,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 336554,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 236467,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 208926,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 174415,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 147848,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 137125,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 129463,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 123568,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59322,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33672,
      "timestamp": "2023-03-21T23:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22625,
      "timestamp": "2023-03-21T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 722405,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 650284,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 380697,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 337851,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 236712,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 209384,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 174624,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 148025,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 137162,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 129520,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 123781,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59327,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33675,
      "timestamp": "2023-03-22T00:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22627,
      "timestamp": "2023-03-22T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 723105,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 650732,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 381229,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 338785,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 236858,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 209564,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 174941,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 148176,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 137168,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 129541,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 123965,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59332,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33680,
      "timestamp": "2023-03-22T01:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T01:00:00-04:00",
      "votes": 22627
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 723654,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 651065,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 381527,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 339291,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 237005,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 209699,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 175128,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 148474,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 137226,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 129552,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 124001,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59365,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33702,
      "timestamp": "2023-03-22T02:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T02:00:00-04:00",
      "votes": 22627
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 724144,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 651406,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 381723,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 339470,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 237023,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 209817,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 175215,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 148514,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 137258,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 129559,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 124024,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59376,
      "timestamp": "2023-03-22T03:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T03:00:00-04:00",
      "votes": 33702
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22629,
      "timestamp": "2023-03-22T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 724825,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 651455,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 382049,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 339606,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 237118,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 209866,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 175255,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 148518,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 137368,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 129571,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 124081,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59378,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33711,
      "timestamp": "2023-03-22T04:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-22T04:00:00-04:00",
      "votes": 22629
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 725112,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 651672,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 382343,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 339792,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 237194,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 209949,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 175286,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 148557,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 137397,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 129614,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 124236,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59421,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33715,
      "timestamp": "2023-03-22T05:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22634,
      "timestamp": "2023-03-22T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 725567,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 652119,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 382571,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 340036,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 237420,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 210140,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 175334,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 148602,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 137476,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 129700,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 124280,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59426,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33718,
      "timestamp": "2023-03-22T06:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22637,
      "timestamp": "2023-03-22T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 726670,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 652893,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 383831,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 340919,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 237782,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 210292,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 175514,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 148733,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 137594,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 129827,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 124326,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59458,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33736,
      "timestamp": "2023-03-22T07:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22638,
      "timestamp": "2023-03-22T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 727963,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 653482,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 384682,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 341628,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 238095,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 210473,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 175686,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 148795,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 137765,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 130003,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 124428,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59519,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33748,
      "timestamp": "2023-03-22T08:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22640,
      "timestamp": "2023-03-22T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 729486,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 654452,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 385422,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 341965,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 238359,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 210727,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 175930,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 148918,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 138025,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 130230,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 124474,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59560,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33760,
      "timestamp": "2023-03-22T09:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22644,
      "timestamp": "2023-03-22T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 730220,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 656061,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 386196,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 342589,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 238747,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 211073,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 176132,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 149063,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 138298,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 130297,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 124618,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59595,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33797,
      "timestamp": "2023-03-22T10:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22654,
      "timestamp": "2023-03-22T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 731321,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 657066,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 387368,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 344019,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 239172,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 211347,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 176263,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 149206,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 138449,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 130357,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 124712,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59620,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33805,
      "timestamp": "2023-03-22T11:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22661,
      "timestamp": "2023-03-22T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 732155,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 657309,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 387780,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 344687,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 240287,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 211628,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 176412,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 149286,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 138687,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 130444,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 124829,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59649,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33820,
      "timestamp": "2023-03-22T12:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22671,
      "timestamp": "2023-03-22T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 733671,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 657785,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 388912,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 345404,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 241169,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 211905,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 176593,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 149354,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 138986,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 130675,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 125179,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59680,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33834,
      "timestamp": "2023-03-22T13:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22672,
      "timestamp": "2023-03-22T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 734560,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 658137,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 389856,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 345835,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 241984,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 212173,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 176711,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 149575,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 139196,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 130827,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 125475,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59709,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33858,
      "timestamp": "2023-03-22T14:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22685,
      "timestamp": "2023-03-22T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 735517,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 658812,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 390688,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 346039,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 242552,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 212327,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 176789,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 149993,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 139229,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 130975,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 125729,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59722,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33910,
      "timestamp": "2023-03-22T15:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22688,
      "timestamp": "2023-03-22T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 738035,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 660328,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 391698,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 346573,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 242920,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 212548,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 176999,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 150184,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 139365,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 131142,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 125942,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59767,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33920,
      "timestamp": "2023-03-22T16:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22690,
      "timestamp": "2023-03-22T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 739035,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 661326,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 393453,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 347274,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 243369,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 212758,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 177326,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 150504,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 139515,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 131257,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 126087,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59782,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33938,
      "timestamp": "2023-03-22T17:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22699,
      "timestamp": "2023-03-22T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 740277,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 662344,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 394728,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 348054,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 243771,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 213105,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 177677,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 150636,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 139689,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 131516,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 126301,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59793,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33954,
      "timestamp": "2023-03-22T18:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22708,
      "timestamp": "2023-03-22T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 741665,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 663649,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 396618,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 349381,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 244283,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 213466,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 177987,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 150880,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 139964,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 131677,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 126569,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59858,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 33978,
      "timestamp": "2023-03-22T19:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22712,
      "timestamp": "2023-03-22T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 742424,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 665615,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 398634,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 350835,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 244732,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 213794,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 178397,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 151100,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 140243,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 132033,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 127032,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59940,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34011,
      "timestamp": "2023-03-22T20:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22720,
      "timestamp": "2023-03-22T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 743987,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 667679,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 401120,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 352507,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 245260,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 214162,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 178893,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 151533,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 140552,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 132412,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 127367,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59947,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34063,
      "timestamp": "2023-03-22T21:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22731,
      "timestamp": "2023-03-22T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 746527,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 669272,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 402879,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 353748,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 245637,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 214589,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 179299,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 151733,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 140812,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 132811,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 127804,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 59987,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34102,
      "timestamp": "2023-03-22T22:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22739,
      "timestamp": "2023-03-22T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 748278,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 670868,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 403651,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 354901,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 245829,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 215073,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 179605,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 152024,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 141034,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 133088,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 128141,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60011,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34129,
      "timestamp": "2023-03-22T23:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22741,
      "timestamp": "2023-03-22T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 749624,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 672283,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 404832,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 355360,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 245997,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 215580,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 179843,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 152291,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 141073,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 133245,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 128454,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60038,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34162,
      "timestamp": "2023-03-23T00:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22744,
      "timestamp": "2023-03-23T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 749993,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 673303,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 405018,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 355566,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 246098,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 215963,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 180042,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 152427,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 141093,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 133397,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 128536,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60070,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34169,
      "timestamp": "2023-03-23T01:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22746,
      "timestamp": "2023-03-23T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 750441,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 673406,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 405047,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 355783,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 246174,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 216122,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 180086,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 152511,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 141115,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 133517,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 128576,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60071,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34174,
      "timestamp": "2023-03-23T02:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T02:00:00-04:00",
      "votes": 22746
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 750870,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 673533,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 405153,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 356255,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 246234,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 216177,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 180108,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 152559,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 141165,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 133603,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 128659,
      "timestamp": "2023-03-23T03:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T03:00:00-04:00",
      "votes": 60071
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T03:00:00-04:00",
      "votes": 34174
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T03:00:00-04:00",
      "votes": 22746
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 751055,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 674036,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 405391,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 356355,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 246264,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 216264,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 180126,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 152570,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 141229,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 133637,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 128690,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60102,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34179,
      "timestamp": "2023-03-23T04:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22747,
      "timestamp": "2023-03-23T04:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 751597,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 674779,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 405742,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 356926,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 246391,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 216293,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 180133,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 152575,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 141326,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 133669,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 128749,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60108,
      "timestamp": "2023-03-23T05:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "color": "#f96302",
      "timestamp": "2023-03-23T05:00:00-04:00",
      "votes": 34179
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22748,
      "timestamp": "2023-03-23T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 752144,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 675185,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 406974,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 357755,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 246528,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 216371,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 180173,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 152622,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 141407,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 133834,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 128785,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60111,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34183,
      "timestamp": "2023-03-23T06:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22749,
      "timestamp": "2023-03-23T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 753381,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 676095,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 408027,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 358473,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 246728,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 216475,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 180243,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 152677,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 141577,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 133927,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 128875,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60126,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34193,
      "timestamp": "2023-03-23T07:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22782,
      "timestamp": "2023-03-23T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 754564,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 676898,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 409675,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 359147,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 247069,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 216570,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 180340,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 152809,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 141789,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 134070,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 128952,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60150,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34201,
      "timestamp": "2023-03-23T08:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22786,
      "timestamp": "2023-03-23T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 755728,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 678088,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 410360,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 359337,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 247352,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 216954,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 180575,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 152874,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 141963,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 134269,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 129096,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60159,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34211,
      "timestamp": "2023-03-23T09:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22794,
      "timestamp": "2023-03-23T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 757223,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 679273,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 411251,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 360337,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 247597,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 217135,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 180709,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 152916,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 142078,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 134483,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 129192,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60179,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34219,
      "timestamp": "2023-03-23T10:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22799,
      "timestamp": "2023-03-23T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 758360,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 679929,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 412247,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 360751,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 247733,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 217534,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 180899,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 153044,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 142296,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 134575,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 129512,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60188,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34229,
      "timestamp": "2023-03-23T11:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22802,
      "timestamp": "2023-03-23T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 759078,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 680246,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 412462,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 361031,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 248087,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 217791,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 181208,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 153116,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 142532,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 134637,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 130176,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60327,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34248,
      "timestamp": "2023-03-23T12:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22816,
      "timestamp": "2023-03-23T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 759558,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 681278,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 412686,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 361218,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 248402,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 218050,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 181401,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 153282,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 142677,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 134770,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 130534,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60384,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34265,
      "timestamp": "2023-03-23T13:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22819,
      "timestamp": "2023-03-23T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 759986,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 682142,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 412854,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 361382,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 248637,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 218351,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 181560,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 153369,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 142969,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 135100,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 130906,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60424,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34302,
      "timestamp": "2023-03-23T14:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22824,
      "timestamp": "2023-03-23T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 760922,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 682580,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 413057,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 361629,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 249054,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 218581,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 181673,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 153470,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 143061,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 135405,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 131137,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60441,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34308,
      "timestamp": "2023-03-23T15:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22827,
      "timestamp": "2023-03-23T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 761660,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 682944,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 413371,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 361964,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 249335,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 218914,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 181804,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 153619,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 143336,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 135557,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 131276,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60464,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34317,
      "timestamp": "2023-03-23T16:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22829,
      "timestamp": "2023-03-23T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 762573,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 683326,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 413678,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 362321,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 249578,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 219089,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 181930,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 153804,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 143457,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 135769,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 131431,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60503,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34320,
      "timestamp": "2023-03-23T17:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22837,
      "timestamp": "2023-03-23T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 763274,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 683743,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 413900,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 362549,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 249905,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 219375,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 182338,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 153878,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 143561,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 136096,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 131638,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60515,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34340,
      "timestamp": "2023-03-23T18:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22839,
      "timestamp": "2023-03-23T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 763964,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 684011,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 414127,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 362952,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 250137,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 219747,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 182565,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 154113,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 143901,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 136237,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 131798,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60567,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34386,
      "timestamp": "2023-03-23T19:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22843,
      "timestamp": "2023-03-23T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 764931,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 684299,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 414346,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 363222,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 250710,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 220066,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 182800,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 154252,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 144292,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 136411,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 131923,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60651,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34405,
      "timestamp": "2023-03-23T20:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22844,
      "timestamp": "2023-03-23T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 766300,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 684594,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 414652,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 363520,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 251564,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 220305,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 183024,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 154463,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 144663,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 136585,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 132204,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60684,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34431,
      "timestamp": "2023-03-23T21:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22857,
      "timestamp": "2023-03-23T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 767167,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 684888,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 414959,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 364085,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 252201,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 220442,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 183226,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 154586,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 145026,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 137086,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 132334,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60753,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34479,
      "timestamp": "2023-03-23T22:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22871,
      "timestamp": "2023-03-23T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 768364,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 685186,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 415258,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 364240,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 252490,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 220791,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 183445,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 154774,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 145151,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 137195,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 132526,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60775,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34497,
      "timestamp": "2023-03-23T23:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22882,
      "timestamp": "2023-03-23T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 769286,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 685413,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 415363,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 364337,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 252631,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 221032,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 183707,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 154949,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 145200,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 137215,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 132719,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60778,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34502,
      "timestamp": "2023-03-24T00:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22884,
      "timestamp": "2023-03-24T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 770034,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 685606,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 415438,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 364472,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 252747,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 221185,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 183901,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 155200,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 145215,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 137250,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 132804,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60781,
      "timestamp": "2023-03-24T01:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T01:00:00-04:00",
      "votes": 34502
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22892,
      "timestamp": "2023-03-24T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 770337,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 685686,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 415445,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 364578,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 252765,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 221445,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 184018,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 155392,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 145321,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 137292,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 132836,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60785,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34503,
      "timestamp": "2023-03-24T02:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T02:00:00-04:00",
      "votes": 22892
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 770517,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 685756,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 415569,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 364644,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 252778,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 221559,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 184127,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 155508,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 145372,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 137303,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 132877,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60792,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34504,
      "timestamp": "2023-03-24T03:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T03:00:00-04:00",
      "votes": 22892
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 770809,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 686335,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 415713,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 364675,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 252784,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 221662,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 184360,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 155515,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 145401,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 137344,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 132941,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60796,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34507,
      "timestamp": "2023-03-24T04:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22893,
      "timestamp": "2023-03-24T04:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 771337,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 686664,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 416040,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 364798,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 252838,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 221730,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 184386,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 155543,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 145419,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 137359,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 133013,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60805,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34510,
      "timestamp": "2023-03-24T05:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22894,
      "timestamp": "2023-03-24T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 772017,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 688049,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 417187,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 364911,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 253078,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 221759,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 184406,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 155559,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 145545,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 137550,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 133039,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60813,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34516,
      "timestamp": "2023-03-24T06:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-24T06:00:00-04:00",
      "votes": 22894
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 772603,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 688803,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 418245,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 365716,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 253240,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 221845,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 184521,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 155614,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 145782,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 137806,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 133105,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60830,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34527,
      "timestamp": "2023-03-24T07:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22899,
      "timestamp": "2023-03-24T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 773575,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 690177,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 419017,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 366028,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 253443,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 222035,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 184779,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 155655,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 146076,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 138128,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 133246,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60848,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34533,
      "timestamp": "2023-03-24T08:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22907,
      "timestamp": "2023-03-24T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 774284,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 691691,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 420358,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 366285,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 253758,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 222298,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 185016,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 155797,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 146192,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 138317,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 133471,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60885,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34547,
      "timestamp": "2023-03-24T09:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22913,
      "timestamp": "2023-03-24T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 774943,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 692949,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 421696,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 366824,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 254084,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 222537,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 185287,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 155954,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 146326,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 138399,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 133601,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60908,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34557,
      "timestamp": "2023-03-24T10:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22916,
      "timestamp": "2023-03-24T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 775464,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 694325,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 422583,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 367357,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 254475,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 222796,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 185858,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 156067,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 146540,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 138467,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 133866,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 60945,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34571,
      "timestamp": "2023-03-24T11:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22926,
      "timestamp": "2023-03-24T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 776447,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 695322,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 423775,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 367887,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 254839,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 223129,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 186096,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 156198,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 146625,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 138566,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 134101,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61007,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34583,
      "timestamp": "2023-03-24T12:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 22931,
      "timestamp": "2023-03-24T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 777219,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 697312,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 424248,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 368633,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 255264,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 223276,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 186191,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 156352,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 146697,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 138705,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 134321,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61020,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34591,
      "timestamp": "2023-03-24T13:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23076,
      "timestamp": "2023-03-24T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 777976,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 698925,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 424931,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 369376,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 255595,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 223444,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 186358,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 156404,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 147206,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 138937,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 134569,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61082,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34597,
      "timestamp": "2023-03-24T14:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23135,
      "timestamp": "2023-03-24T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 779272,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 699312,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 425817,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 370392,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 255950,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 223586,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 186509,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 156506,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 147389,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 139127,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 134693,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61109,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34609,
      "timestamp": "2023-03-24T15:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23158,
      "timestamp": "2023-03-24T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 780139,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 700823,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 427044,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 371239,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 256369,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 223840,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 186645,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 156743,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 147836,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 139304,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 134801,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61158,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34622,
      "timestamp": "2023-03-24T16:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23214,
      "timestamp": "2023-03-24T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 781046,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 703049,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 428300,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 372886,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 256763,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 224191,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 186979,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 156938,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 148320,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 139557,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 135038,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61194,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34634,
      "timestamp": "2023-03-24T17:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23240,
      "timestamp": "2023-03-24T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 783250,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 704285,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 430198,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 374272,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 257256,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 224568,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 187216,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 157143,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 148555,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 139740,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 135153,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61219,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34650,
      "timestamp": "2023-03-24T18:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23269,
      "timestamp": "2023-03-24T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 784864,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 705950,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 432139,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 375733,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 257941,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 224955,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 187663,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 157297,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 149040,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 139996,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 135289,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61247,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34676,
      "timestamp": "2023-03-24T19:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23276,
      "timestamp": "2023-03-24T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 787350,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 707905,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 433143,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 377489,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 258479,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 225216,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 188006,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 157496,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 149258,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 140321,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 135393,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61276,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34705,
      "timestamp": "2023-03-24T20:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23326,
      "timestamp": "2023-03-24T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 790676,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 710000,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 434741,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 378983,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 258899,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 225563,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 188232,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 157728,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 149465,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 140620,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 135580,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61312,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34736,
      "timestamp": "2023-03-24T21:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23339,
      "timestamp": "2023-03-24T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 793085,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 711043,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 436135,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 379850,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 259373,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 225952,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 188415,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 158001,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 149724,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 141044,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 135744,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61339,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34762,
      "timestamp": "2023-03-24T22:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23349,
      "timestamp": "2023-03-24T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 794464,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 712004,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 437880,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 380787,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 259832,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 226301,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 188753,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 158193,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 149903,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 141190,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 135958,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61351,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34793,
      "timestamp": "2023-03-24T23:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23362,
      "timestamp": "2023-03-24T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 795997,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 713724,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 438679,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 381771,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 260172,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 226485,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 189038,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 158525,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 150126,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 141315,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 136171,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61366,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34848,
      "timestamp": "2023-03-25T00:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23373,
      "timestamp": "2023-03-25T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 796985,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 714338,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 439125,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 382562,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 260287,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 226743,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 189128,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 158751,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 150145,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 141410,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 136292,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61376,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34852,
      "timestamp": "2023-03-25T01:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23382,
      "timestamp": "2023-03-25T01:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 797313,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 714692,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 439431,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 383081,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 260313,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 226799,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 189140,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 158777,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 150190,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 141442,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 136316,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61379,
      "timestamp": "2023-03-25T02:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T02:00:00-04:00",
      "votes": 34852
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23383,
      "timestamp": "2023-03-25T02:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 797675,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 714812,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 439657,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 383164,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 260364,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 226846,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 189151,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 158805,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 150270,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 141494,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 136335,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61380,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34853,
      "timestamp": "2023-03-25T03:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T03:00:00-04:00",
      "votes": 23383
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 798040,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 715287,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 440697,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 383370,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 260419,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 226922,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 189159,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 158806,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 150332,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 141513,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 136381,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61387,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34860,
      "timestamp": "2023-03-25T04:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23390,
      "timestamp": "2023-03-25T04:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 798657,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 715617,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 440959,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 383416,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 260497,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 226941,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 189176,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 158841,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 150398,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 141555,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 136413,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61396,
      "timestamp": "2023-03-25T05:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T05:00:00-04:00",
      "votes": 34860
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23391,
      "timestamp": "2023-03-25T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 799307,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 716409,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 441251,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 383755,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 260581,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 226962,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 189231,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 158917,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 150435,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 141609,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 136432,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61402,
      "timestamp": "2023-03-25T06:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T06:00:00-04:00",
      "votes": 34860
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23392,
      "timestamp": "2023-03-25T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 800218,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 717040,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 442197,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 384217,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 260903,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 227033,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 189246,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 159018,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 150625,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 141767,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 136481,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61418,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34876,
      "timestamp": "2023-03-25T07:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23394,
      "timestamp": "2023-03-25T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 801355,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 718080,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 443577,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 384905,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 261151,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 227157,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 189357,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 159044,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 150757,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 142040,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 136578,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61428,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34883,
      "timestamp": "2023-03-25T08:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23395,
      "timestamp": "2023-03-25T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 803090,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 719215,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 445399,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 385453,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 261471,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 227342,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 189672,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 159188,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 150915,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 142291,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 136705,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61451,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34900,
      "timestamp": "2023-03-25T09:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23408,
      "timestamp": "2023-03-25T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 803970,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 720946,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 446180,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 386742,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 261864,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 227708,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 189892,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 159335,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 151094,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 142552,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 136847,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61460,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34914,
      "timestamp": "2023-03-25T10:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23415,
      "timestamp": "2023-03-25T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 805120,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 722455,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 447663,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 388006,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 262131,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 227975,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 189944,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 159471,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 151244,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 142843,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 137031,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61510,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34944,
      "timestamp": "2023-03-25T11:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23427,
      "timestamp": "2023-03-25T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 806633,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 723166,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 448507,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 388922,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 262257,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 228326,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 190093,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 159635,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 151441,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 142993,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 137179,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61518,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34953,
      "timestamp": "2023-03-25T12:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23433,
      "timestamp": "2023-03-25T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 807688,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 725001,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 449500,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 389742,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 262608,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 228664,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 190219,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 159712,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 151615,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 143171,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 137342,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61533,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 34963,
      "timestamp": "2023-03-25T13:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23440,
      "timestamp": "2023-03-25T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 808402,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 726394,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 451003,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 391607,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 262921,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 229018,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 190388,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 159801,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 151811,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 143300,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 137462,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61563,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35006,
      "timestamp": "2023-03-25T14:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23450,
      "timestamp": "2023-03-25T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 809513,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 727170,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 451638,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 392594,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 263315,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 229196,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 190557,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 160018,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 151959,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 143561,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 137581,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61585,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35010,
      "timestamp": "2023-03-25T15:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23458,
      "timestamp": "2023-03-25T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 810321,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 728760,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 452483,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 392975,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 263658,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 229438,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 190895,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 160133,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 152200,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 143846,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 137738,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61601,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35023,
      "timestamp": "2023-03-25T16:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23464,
      "timestamp": "2023-03-25T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 811351,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 730080,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 454104,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 393670,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 263946,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 229695,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 191084,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 160224,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 152321,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 144049,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 137893,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61629,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35046,
      "timestamp": "2023-03-25T17:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23477,
      "timestamp": "2023-03-25T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 812451,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 731109,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 455695,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 395395,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 264372,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 229888,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 191337,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 160354,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 152515,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 144464,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 138117,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61658,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35056,
      "timestamp": "2023-03-25T18:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23484,
      "timestamp": "2023-03-25T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 814365,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 732436,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 457239,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 396372,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 264675,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 230257,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 191635,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 160531,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 152748,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 144630,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 138256,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61698,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35061,
      "timestamp": "2023-03-25T19:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23485,
      "timestamp": "2023-03-25T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 815810,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 733947,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 459045,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 397748,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 265211,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 230562,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 191973,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 160663,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 152886,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 144813,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 138348,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61745,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35095,
      "timestamp": "2023-03-25T20:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23499,
      "timestamp": "2023-03-25T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 816935,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 735795,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 461165,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 400584,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 265554,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 231038,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 192319,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 160805,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 153291,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 145072,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 138488,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61780,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35135,
      "timestamp": "2023-03-25T21:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23526,
      "timestamp": "2023-03-25T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 818667,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 737369,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 462980,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 401333,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 265930,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 231438,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 192421,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 160989,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 153504,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 145224,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 138612,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61800,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35145,
      "timestamp": "2023-03-25T22:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23540,
      "timestamp": "2023-03-25T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 819874,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 739205,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 464323,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 402287,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 266214,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 231974,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 192512,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161154,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 153596,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 145356,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 138715,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61815,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35165,
      "timestamp": "2023-03-25T23:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-25T23:00:00-04:00",
      "votes": 23540
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 821210,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 740444,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 465928,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 403138,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 266382,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 232283,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 192678,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161260,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 153611,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 145490,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 138823,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61819,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35166,
      "timestamp": "2023-03-26T00:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23541,
      "timestamp": "2023-03-26T00:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 821957,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 741411,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 466825,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 403806,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 266505,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 232571,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 192846,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161310,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 153681,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 145527,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 138995,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T01:00:00-04:00",
      "votes": 61819
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35169,
      "timestamp": "2023-03-26T01:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T01:00:00-04:00",
      "votes": 23541
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 822425,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 742119,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 467234,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 404151,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 266622,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 232712,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 193005,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161348,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 153733,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 145573,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 139090,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61820,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35172,
      "timestamp": "2023-03-26T02:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T02:00:00-04:00",
      "votes": 23541
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 822761,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 742447,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 468124,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 404292,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 266670,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 232855,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 193028,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161351,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 153739,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 145627,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 139174,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61830,
      "timestamp": "2023-03-26T03:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T03:00:00-04:00",
      "votes": 35172
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23543,
      "timestamp": "2023-03-26T03:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 823134,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 742463,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 468335,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 404743,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 266711,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 232980,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 193074,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161357,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 153753,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 145652,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 139240,
      "timestamp": "2023-03-26T04:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 61830
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 35172
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T04:00:00-04:00",
      "votes": 23543
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 823522,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 743017,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 468560,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 404777,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 266805,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 233057,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 193156,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161389,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 153781,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 145661,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 139301,
      "timestamp": "2023-03-26T05:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 61830
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "color": "#f96302",
      "timestamp": "2023-03-26T05:00:00-04:00",
      "votes": 35172
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23544,
      "timestamp": "2023-03-26T05:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 823847,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 743237,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 469142,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 404804,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 266845,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 233156,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 193206,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161405,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 153796,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 145721,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 139307,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61834,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35173,
      "timestamp": "2023-03-26T06:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23545,
      "timestamp": "2023-03-26T06:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 824465,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 744008,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 469587,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 405004,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 267004,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 233165,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 193338,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161428,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 153856,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 145823,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 139322,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61837,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35176,
      "timestamp": "2023-03-26T07:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23546,
      "timestamp": "2023-03-26T07:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 825136,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 745458,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 471388,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 405415,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 267250,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 233250,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 193565,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161457,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 154039,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 146022,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 139481,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61840,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35178,
      "timestamp": "2023-03-26T08:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23547,
      "timestamp": "2023-03-26T08:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 826112,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 746287,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 472353,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 406485,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 267509,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 233365,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 193695,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161495,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 154119,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 146099,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 139588,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61857,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35184,
      "timestamp": "2023-03-26T09:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23551,
      "timestamp": "2023-03-26T09:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 827434,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 746989,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 473910,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 407658,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 267662,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 233453,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 193832,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161570,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 154161,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 146177,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 139784,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61866,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35189,
      "timestamp": "2023-03-26T10:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23562,
      "timestamp": "2023-03-26T10:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 828074,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 747675,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 475823,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 408288,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 267788,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 233612,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 194106,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161632,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 154203,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 146270,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 139955,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61873,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35194,
      "timestamp": "2023-03-26T11:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23572,
      "timestamp": "2023-03-26T11:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 828759,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 748931,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 477407,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 409072,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 268082,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 233755,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 194189,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161725,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 154265,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 146482,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 140082,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61876,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35204,
      "timestamp": "2023-03-26T12:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23575,
      "timestamp": "2023-03-26T12:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 829586,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 749318,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 478601,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 410223,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 268311,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 233995,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 194287,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161782,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 154324,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 146601,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 140144,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61895,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35212,
      "timestamp": "2023-03-26T13:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23579,
      "timestamp": "2023-03-26T13:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 830348,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 750194,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 480066,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 411660,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 268469,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 234162,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 194414,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161905,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 154500,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 146665,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 140200,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61914,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35220,
      "timestamp": "2023-03-26T14:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23587,
      "timestamp": "2023-03-26T14:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 831141,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 751264,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 482892,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 412406,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 268753,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 234478,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 194755,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 161995,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 154673,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 146836,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 140343,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61925,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35231,
      "timestamp": "2023-03-26T15:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23589,
      "timestamp": "2023-03-26T15:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 831982,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 752025,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 484430,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 413479,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 269122,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 234809,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 195125,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 162105,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 155094,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 147048,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 140459,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61936,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35235,
      "timestamp": "2023-03-26T16:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23599,
      "timestamp": "2023-03-26T16:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 832905,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 752706,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 485684,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 414487,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 269293,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 235096,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 195374,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 162210,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 155434,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 147221,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 140605,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61991,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35249,
      "timestamp": "2023-03-26T17:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23606,
      "timestamp": "2023-03-26T17:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 833823,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 753852,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 487353,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 416429,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 269541,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 235282,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 195733,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 162283,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 155577,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 147464,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 140717,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 61999,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35259,
      "timestamp": "2023-03-26T18:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23623,
      "timestamp": "2023-03-26T18:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 835163,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 755539,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 488392,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 418231,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 270072,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 235457,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 195932,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 162404,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 155727,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 147628,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 140851,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 62019,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35264,
      "timestamp": "2023-03-26T19:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23625,
      "timestamp": "2023-03-26T19:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 837015,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 756246,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 492572,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 420215,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 270406,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 235678,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 196126,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 162456,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 156014,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 147909,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 140929,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 62026,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35277,
      "timestamp": "2023-03-26T20:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23630,
      "timestamp": "2023-03-26T20:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 839020,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 757516,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 495300,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 422182,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 270719,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 236112,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 196336,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 162548,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 156156,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 148110,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 141059,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 62051,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35314,
      "timestamp": "2023-03-26T21:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23631,
      "timestamp": "2023-03-26T21:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 840439,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 757719,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 495797,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 422583,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 271155,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 236489,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 196533,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 162677,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 156259,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 148282,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 141322,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 62085,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35336,
      "timestamp": "2023-03-26T22:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23639,
      "timestamp": "2023-03-26T22:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 841870,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 758102,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 496333,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 422954,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 271446,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 237040,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 196744,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 162939,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 156438,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 148542,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 141417,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "votes": 62091,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "votes": 35344,
      "timestamp": "2023-03-26T23:00:00-04:00"
    },
    {
      "label": "Delaware State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "votes": 23651,
      "timestamp": "2023-03-26T23:00:00-04:00"
    }
  ],
  [
    {
      "label": "Alabama A&M University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/0565a073-390f-4d20-bb8f-f0acdc7be441.png",
      "votes": 842218,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Jackson State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b92c2dd0-9e15-4c23-aa5b-0c5843cf2928.png",
      "votes": 758183,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Albany State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5d19940f-fb78-4957-bc58-21a88ede2959.png",
      "votes": 496395,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Howard University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/5fded03c-c64c-41f2-a41f-de8617f6a2c9.png",
      "votes": 423025,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Hampton University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/6a1641c1-9d44-44ab-9be8-a4401acc64f5.png",
      "votes": 271490,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Grambling State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/8b2d2ed6-5f3e-48f5-a0ab-ec4cadbe1baa.png",
      "votes": 237272,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Alabama State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/bfa77704-ced2-40e0-924c-0d3473393953.png",
      "votes": 196798,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Southern University and A&M College",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/fa52ee86-7df9-4913-a660-ef7c973ab62a.png",
      "votes": 163058,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Winston-Salem State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/11e75e27-e993-4add-ad61-6ee3168b73f7.png",
      "votes": 156479,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Norfolk State University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/7797305f-0c53-4f44-8652-181588f5c4ec.png",
      "votes": 148587,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "Florida Agricultural and Mechanical University",
      "color": "#f96302",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/715fa7e9-be74-4434-99bd-1bcc1235e519.png",
      "votes": 141425,
      "timestamp": "2023-03-27T00:00:00-04:00"
    },
    {
      "label": "North Carolina Central University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/b56e9ff0-964f-4858-82a6-f7e0efcdf6fc.png",
      "color": "#f96302",
      "timestamp": "2023-03-27T00:00:00-04:00",
      "votes": 62091
    },
    {
      "label": "North Carolina Agricultural & Technical State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c5787187-b190-4db7-ba51-5ebe2089a508.png",
      "color": "#f96302",
      "timestamp": "2023-03-27T00:00:00-04:00",
      "votes": 35344
    },
    {
      "label": "Delaware State University",
      "logo": "https://bucketeer-b30c9246-c3c2-4f61-b8b6-f641baa6237a.s3.amazonaws.com/public/leaderboard-thumbnails/c9bf91b2-0399-46db-8e25-f77f384315d7.png",
      "color": "#f96302",
      "timestamp": "2023-03-27T00:00:00-04:00",
      "votes": 23651
    }
  ]
]
